<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
    <defs />
    <defs>
      <clipPath id="a" clipPathUnits="userSpaceOnUse">
        <path
          d="M150 300C67.157 300 0 232.843 0 150S67.157 0 150 0s150 67.157 150 150-67.157 150-150 150z" />
      </clipPath>
    </defs>
    <g clip-path="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 400)">
      <path d="M-45 300h450V0H-45z" fill="#c60b1e" />
      <path d="M-45 225h450V75H-45z" fill="#ffc400" />
      <path
        d="M55.794 166.656s-.306 0-.474.096c-.168.096-.679.576-.679.576l-.407.294-.372.51s-.438.708-.24 1.254c.204.546.545.738.852.9.306.156.948.354.948.354s.51.222.678.252c.167.036.78.192.78.192s.168.096.336.162c.174.066.408.066.546.096.132.036.474.144.678.156.312.012.816-.06.984-.06.167 0 .744-.03.984-.03.233 0 1.08.066 1.32.066.234 0 .408.03.678 0 .27-.036.744-.192.882-.258s.948-.354 1.253-.45c.307-.096 1.05-.222 1.393-.384.336-.162.546-.432.714-.66.168-.222.204-.468.27-.63.066-.156.066-.504 0-.666-.066-.156-.306-.486-.306-.486l-.372-.612-.474-.384s-.342-.324-.612-.288c-.27.024-3.018.516-4.782.516-1.764 0-4.584-.516-4.584-.516"
        fill="#ad1519" />
      <path
        d="M55.794 166.656s-.306 0-.474.096c-.168.096-.679.576-.679.576l-.407.294-.372.51s-.438.708-.24 1.254c.204.546.545.738.852.9.306.156.948.354.948.354s.51.222.678.252c.167.036.78.192.78.192s.168.096.336.162c.174.066.408.066.546.096.132.036.474.144.678.156.312.012.816-.06.984-.06.167 0 .744-.03.984-.03.233 0 1.08.066 1.32.066.234 0 .408.03.678 0 .27-.036.744-.192.882-.258s.948-.354 1.253-.45c.307-.096 1.05-.222 1.393-.384.336-.162.546-.432.714-.66.168-.222.204-.468.27-.63.066-.156.066-.504 0-.666-.066-.156-.306-.486-.306-.486l-.372-.612-.474-.384s-.342-.324-.612-.288c-.27.024-3.018.516-4.782.516-1.764 0-4.584-.516-4.584-.516z"
        fill="none"
        stroke="#000"
        stroke-width=".156"
        stroke-linejoin="round" />
      <path
        d="M59.568 170.592c0 .829.372 1.494.829 1.494.455 0 .827-.665.827-1.494 0-.828-.372-1.5-.827-1.5-.457 0-.83.672-.83 1.5"
        fill="#c8b100" />
      <path
        d="M59.568 170.592c0 .829.372 1.494.829 1.494.455 0 .827-.665.827-1.494 0-.828-.372-1.5-.827-1.5-.457 0-.83.672-.83 1.5z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M60.03 170.592c0 .762.168 1.38.378 1.38.216 0 .384-.618.384-1.38 0-.756-.168-1.374-.384-1.374-.21 0-.378.618-.378 1.374"
        fill="#c8b100" />
      <path
        d="M60.03 170.592c0 .762.168 1.38.378 1.38.216 0 .384-.618.384-1.38 0-.756-.168-1.374-.384-1.374-.21 0-.378.618-.378 1.374z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M59.85 172.176c0 .288.246.522.558.522.3 0 .552-.234.552-.522 0-.294-.252-.522-.552-.522-.312 0-.558.228-.558.522"
        fill="#c8b100" />
      <path
        d="M60.798 172.356v-.348h-.858v.348h.282v.792h-.372v.342h.372v.342h.36v-.342h.372v-.342h-.372v-.792z"
        fill="#c8b100" />
      <path
        d="M60.798 172.356v-.348h-.858v.348h.282v.792h-.372v.342h.372v.342h.36v-.342h.372v-.342h-.372v-.792h.216"
        fill="none"
        stroke="#000"
        stroke-width=".18" />
      <path
        d="M61.176 172.356v-.348h-1.518v.348h.564v.792h-.372v.342h.372v.342h.36v-.342h.372v-.342h-.372v-.792z"
        fill="#c8b100" />
      <path
        d="M61.176 172.356v-.348h-1.518v.348h.564v.792h-.372v.342h.372v.342h.36v-.342h.372v-.342h-.372v-.792h.594"
        fill="none"
        stroke="#000"
        stroke-width=".18" />
      <path
        d="M60.564 172.68a.537.537 0 00.396-.504c0-.294-.252-.522-.552-.522-.312 0-.558.228-.558.522 0 .24.174.444.414.504"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M60.408 166.752h-2.886l-.066.708-.138.738-.138.918c-.798 1.05-1.53 1.74-1.776 1.59.06.192.132.336.282.426.708.42 2.166-.588 3.264-2.244.096-.15.192-.3.276-.45h2.382c.084.15.18.3.276.45 1.092 1.656 2.556 2.664 3.258 2.244.156-.09.222-.234.282-.426-.246.144-.972-.54-1.776-1.59l-.138-.918-.138-.738-.06-.708h-2.904"
        fill="#c8b100" />
      <path
        d="M60.408 166.752h-2.886l-.066.708-.138.738-.138.918c-.798 1.05-1.53 1.74-1.776 1.59.06.192.132.336.282.426.708.42 2.166-.588 3.264-2.244.096-.15.192-.3.276-.45h2.382c.084.15.18.3.276.45 1.092 1.656 2.556 2.664 3.258 2.244.156-.09.222-.234.282-.426-.246.144-.972-.54-1.776-1.59l-.138-.918-.138-.738-.06-.708z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M65.298 170.736c-.546.318-1.806-.684-2.838-2.244m-6.93 2.244c.546.318 1.812-.684 2.838-2.244"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M56.148 165.45c-.12.342-.348.648-.348.648 1.17.342 2.796.558 4.602.564 1.806-.006 3.45-.222 4.614-.564 0 0-.132-.228-.312-.546a4.126 4.126 0 01-.228-.486c-1.05.324-2.412.486-4.08.492-1.674-.006-3.276-.21-4.116-.516.012 0-.06.192-.138.408h.006"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M60.402 163.962c1.458.006 3.066.228 3.66.378.396.12.63.294.588.504-.024.096-.108.18-.222.228-.876.282-2.442.48-4.026.48-1.578 0-3.162-.198-4.032-.48-.114-.048-.198-.132-.222-.228-.042-.21.192-.384.588-.504.594-.15 2.208-.372 3.666-.378"
        fill="#c8b100" />
      <path
        d="M60.402 163.962c1.458.006 3.066.228 3.66.378.396.12.63.294.588.504-.024.096-.108.18-.222.228-.876.282-2.442.48-4.026.48-1.578 0-3.162-.198-4.032-.48-.114-.048-.198-.132-.222-.228-.042-.21.192-.384.588-.504.594-.15 2.208-.372 3.666-.378z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M65.088 166.752l-.354.318s-.342-.204-.768-.144c-.42.066-.558.582-.558.582s-.474-.402-.864-.372c-.39.036-.642.372-.642.372s-.426-.306-.798-.276c-.372.036-.726.498-.726.498s-.378-.48-.75-.516c-.372-.03-.678.324-.678.324s-.168-.354-.642-.432c-.474-.078-.882.372-.882.372s-.27-.438-.594-.552c-.324-.108-.744.162-.744.162s-.072-.162-.12-.258-.186-.114-.186-.114l.108-.282c1.158.336 2.736.546 4.518.546 1.782 0 3.402-.21 4.566-.552l.12.324"
        fill="#c8b100" />
      <path
        d="M65.088 166.752l-.354.318s-.342-.204-.768-.144c-.42.066-.558.582-.558.582s-.474-.402-.864-.372c-.39.036-.642.372-.642.372s-.426-.306-.798-.276c-.372.036-.726.498-.726.498s-.378-.48-.75-.516c-.372-.03-.678.324-.678.324s-.168-.354-.642-.432c-.474-.078-.882.372-.882.372s-.27-.438-.594-.552c-.324-.108-.744.162-.744.162s-.072-.162-.12-.258-.186-.114-.186-.114l.108-.282c1.158.336 2.736.546 4.518.546 1.782 0 3.402-.21 4.566-.552l.12.324z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M60.414 168.306l.168-.03a.57.57 0 01-.036-.228c0-.348.3-.63.672-.63.294 0 .546.186.636.438.006-.006.066.228.09.228.018 0 .018-.246.03-.246.042-.318.33-.534.66-.534.372 0 .666.282.666.636 0 .024 0 .048-.006.072l.21.21.114-.264a.6.6 0 01-.06-.276c0-.336.282-.606.636-.606.222 0 .414.108.528.27l.138.174v-.216c0-.204.084-.396.294-.426 0 0 .228-.018.546.228.312.246.48.45.48.45l.018-.252s-.306-.504-.582-.66c-.15-.09-.384-.186-.57-.15-.192.03-.33.186-.402.366a.93.93 0 00-.48-.132c-.378 0-.72.21-.852.516a.936.936 0 00-.696-.3.984.984 0 00-.756.348.941.941 0 00-.654-.258c-.33 0-.63.168-.798.414a.985.985 0 00-.804-.414.941.941 0 00-.654.258.98.98 0 00-1.452-.048c-.132-.306-.474-.516-.852-.516a.908.908 0 00-.474.132c-.072-.18-.21-.336-.408-.366-.18-.036-.414.06-.564.15-.282.156-.612.66-.612.66l.042.252s.174-.204.486-.45c.312-.246.546-.228.546-.228.204.03.294.222.294.426v.216l.132-.174a.642.642 0 01.528-.27c.354 0 .636.27.636.606a.534.534 0 01-.06.276l.114.264.21-.21c-.006-.024-.006-.048-.006-.072 0-.354.294-.636.666-.636.33 0 .618.216.666.534.006 0 .006.246.024.246.03 0 .084-.234.096-.228a.664.664 0 01.636-.438c.366 0 .666.282.666.63 0 .084 0 .156-.03.228l.174.03"
        fill="#c8b100" />
      <path
        d="M60.414 168.306l.168-.03a.57.57 0 01-.036-.228c0-.348.3-.63.672-.63.294 0 .546.186.636.438.006-.006.066.228.09.228.018 0 .018-.246.03-.246.042-.318.33-.534.66-.534.372 0 .666.282.666.636 0 .024 0 .048-.006.072l.21.21.114-.264a.6.6 0 01-.06-.276c0-.336.282-.606.636-.606.222 0 .414.108.528.27l.138.174v-.216c0-.204.084-.396.294-.426 0 0 .228-.018.546.228.312.246.48.45.48.45l.018-.252s-.306-.504-.582-.66c-.15-.09-.384-.186-.57-.15-.192.03-.33.186-.402.366a.93.93 0 00-.48-.132c-.378 0-.72.21-.852.516a.936.936 0 00-.696-.3.984.984 0 00-.756.348.941.941 0 00-.654-.258c-.33 0-.63.168-.798.414a.985.985 0 00-.804-.414.941.941 0 00-.654.258.98.98 0 00-1.452-.048c-.132-.306-.474-.516-.852-.516a.908.908 0 00-.474.132c-.072-.18-.21-.336-.408-.366-.18-.036-.414.06-.564.15-.282.156-.612.66-.612.66l.042.252s.174-.204.486-.45c.312-.246.546-.228.546-.228.204.03.294.222.294.426v.216l.132-.174a.642.642 0 01.528-.27c.354 0 .636.27.636.606a.534.534 0 01-.06.276l.114.264.21-.21c-.006-.024-.006-.048-.006-.072 0-.354.294-.636.666-.636.33 0 .618.216.666.534.006 0 .006.246.024.246.03 0 .084-.234.096-.228a.664.664 0 01.636-.438c.366 0 .666.282.666.63 0 .084 0 .156-.03.228l.174.03z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M60.402 166.662c-1.806-.006-3.432-.222-4.602-.564-.078-.024-.174.036-.198.102-.024.078.03.168.108.192 1.17.36 2.838.588 4.692.588s3.528-.228 4.698-.588c.078-.024.132-.114.108-.192-.024-.066-.12-.126-.198-.102-1.17.342-2.802.558-4.608.564"
        fill="#c8b100" />
      <path
        d="M60.402 166.662c-1.806-.006-3.432-.222-4.602-.564-.078-.024-.174.036-.198.102-.024.078.03.168.108.192 1.17.36 2.838.588 4.692.588s3.528-.228 4.698-.588c.078-.024.132-.114.108-.192-.024-.066-.12-.126-.198-.102-1.17.342-2.802.558-4.608.564z"
        fill="none"
        stroke="#000"
        stroke-width=".156"
        stroke-linejoin="round" />
      <path
        d="M58.65 166.02c0 .132.12.246.264.246.144 0 .264-.114.264-.246 0-.138-.12-.246-.264-.246-.144 0-.264.108-.264.246"
        fill="#fff" />
      <path
        d="M58.65 166.02c0 .132.12.246.264.246.144 0 .264-.114.264-.246 0-.138-.12-.246-.264-.246-.144 0-.264.108-.264.246z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M60.42 165.912h-.577c-.107 0-.197.084-.197.186s.084.186.192.186h1.176c.114 0 .198-.084.198-.186s-.09-.186-.198-.186h-.594"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M57.51 165.714l-.414-.066c-.108-.012-.21.054-.228.156a.192.192 0 00.162.21l.42.06.426.066c.108.012.204-.054.222-.15a.189.189 0 00-.162-.21l-.426-.066"
        fill="#058e6e"
        stroke="#000"
        stroke-width=".156" />
      <path d="M55.83 165.42l.186.3.39-.079-.228-.335z" fill="#ad1519" />
      <path
        d="M55.83 165.42l.186.3.39-.079-.228-.335-.348.114"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M61.632 166.02c0 .132.114.246.264.246a.254.254 0 00.258-.246.25.25 0 00-.258-.246c-.15 0-.264.108-.264.246"
        fill="#fff" />
      <path
        d="M61.632 166.02c0 .132.114.246.264.246a.254.254 0 00.258-.246.25.25 0 00-.258-.246c-.15 0-.264.108-.264.246z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M63.3 165.714l.414-.066c.108-.012.21.054.228.156a.188.188 0 01-.162.21l-.42.06-.426.066c-.108.012-.21-.054-.222-.15a.18.18 0 01.162-.21l.426-.066"
        fill="#058e6e"
        stroke="#000"
        stroke-width=".156" />
      <path d="M64.944 165.402l-.15.318-.403-.036.193-.354z" fill="#ad1519" />
      <path
        d="M64.944 165.402l-.15.318-.403-.036.193-.354.36.072"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M60.396 164.304c-1.458 0-2.779.132-3.78.39 1.001.258 2.322.414 3.78.42 1.464 0 2.79-.162 3.798-.42-1.008-.258-2.334-.39-3.798-.39"
        fill="#ad1519" />
      <path
        d="M60.396 164.304c-1.458 0-2.779.132-3.78.39 1.001.258 2.322.414 3.78.42 1.464 0 2.79-.162 3.798-.42-1.008-.258-2.334-.39-3.798-.39z"
        fill="none"
        stroke="#000"
        stroke-width=".156"
        stroke-linejoin="round" />
      <path
        d="M65.004 167.472c.036.108 0 .222-.078.252-.084.018-.18-.054-.222-.162-.036-.114 0-.228.084-.252.078-.024.174.048.216.162"
        fill="#c8b100" />
      <path
        d="M65.004 167.472c.036.108 0 .222-.078.252-.084.018-.18-.054-.222-.162-.036-.114 0-.228.084-.252.078-.024.174.048.216.162z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M62.1 168.03c.012.12-.048.222-.132.234-.084.012-.168-.078-.18-.198-.012-.114.042-.222.126-.228.084-.012.168.078.186.192"
        fill="#c8b100" />
      <path
        d="M62.1 168.03c.012.12-.048.222-.132.234-.084.012-.168-.078-.18-.198-.012-.114.042-.222.126-.228.084-.012.168.078.186.192z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M58.722 168.03c-.018.12.042.222.126.234.084.012.168-.078.18-.198.018-.114-.042-.222-.126-.228-.084-.012-.168.078-.18.192"
        fill="#c8b100" />
      <path
        d="M58.722 168.03c-.018.12.042.222.126.234.084.012.168-.078.18-.198.018-.114-.042-.222-.126-.228-.084-.012-.168.078-.18.192z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M55.812 167.472c-.036.108 0 .222.078.252.084.018.18-.054.222-.162.036-.114 0-.228-.084-.252-.078-.024-.174.048-.216.162"
        fill="#c8b100" />
      <path
        d="M55.812 167.472c-.036.108 0 .222.078.252.084.018.18-.054.222-.162.036-.114 0-.228-.084-.252-.078-.024-.174.048-.216.162z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M60.396 169.71l-.516-.312.384-.828.132-.084.132.084.384.828z" fill="#c8b100" />
      <path
        d="M60.396 169.71l-.516-.312.384-.828.132-.084.132.084.384.828-.516.312"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M59.268 168.456l.24-.342.804.252.085.108-.091.12-.798.234z" fill="#c8b100" />
      <path
        d="M59.268 168.456l.24-.342.804.252.085.108-.091.12-.798.234-.24-.372"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M61.53 168.456l-.234-.342-.804.252-.084.108.084.12.804.234z" fill="#c8b100" />
      <path
        d="M61.53 168.456l-.234-.342-.804.252-.084.108.084.12.804.234.234-.372"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M57.048 169.344l-.402-.384.516-.684.138-.054.102.108.18.822z" fill="#c8b100" />
      <path
        d="M57.048 169.344l-.402-.384.516-.684.138-.054.102.108.18.822-.534.192"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M56.202 167.976l.306-.288.732.396.054.126-.102.102-.84.072z" fill="#c8b100" />
      <path
        d="M56.202 167.976l.306-.288.732.396.054.126-.102.102-.84.072-.15-.408"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M58.416 168.42l-.156-.379-.84.08-.108.095.06.132.732.384z" fill="#c8b100" />
      <path
        d="M58.416 168.42l-.156-.379-.84.08-.108.095.06.132.732.384.312-.312"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M55.392 167.868l-.066-.396-.84-.09-.126.072.024.138.637.522z" fill="#c8b100" />
      <path
        d="M55.392 167.868l-.066-.396-.84-.09-.126.072.024.138.637.522.37-.246"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M57.012 168.21c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276"
        fill="#c8b100" />
      <path
        d="M57.012 168.21c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M63.762 169.344l.402-.384-.516-.684-.138-.054-.102.108-.18.822z" fill="#c8b100" />
      <path
        d="M63.762 169.344l.402-.384-.516-.684-.138-.054-.102.108-.18.822.534.192"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M64.608 167.976l-.306-.288-.732.396-.06.126.114.102.84.072z" fill="#c8b100" />
      <path
        d="M64.608 167.976l-.306-.288-.732.396-.06.126.114.102.84.072.144-.408"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M62.394 168.42l.156-.379.84.08.108.095-.06.132-.732.384-.313-.312"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".156" />
      <path d="M65.304 167.868l.066-.396.84-.09.126.072-.03.138-.63.522z" fill="#c8b100" />
      <path
        d="M65.304 167.868l.066-.396.84-.09.126.072-.03.138-.63.522-.372-.246"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M60.108 168.474c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276"
        fill="#c8b100" />
      <path
        d="M60.108 168.474c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M63.216 168.21c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276"
        fill="#c8b100" />
      <path
        d="M63.216 168.21c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M54.258 167.4c-.006-.006-.228.288-.39.438-.12.108-.408.198-.408.198 0 .048.168.168.348.168.108 0 .21-.042.27-.12l.024.12s.144-.03.21-.192c.072-.174.03-.432.03-.432s-.03-.12-.084-.18"
        fill="#c8b100" />
      <path
        d="M54.258 167.4c-.006-.006-.228.288-.39.438-.12.108-.408.198-.408.198 0 .048.168.168.348.168.108 0 .21-.042.27-.12l.024.12s.144-.03.21-.192c.072-.174.03-.432.03-.432s-.03-.12-.084-.18z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M54.27 167.55c.071.072.216.054.318-.036.108-.09.144-.228.072-.3-.072-.078-.217-.06-.319.036-.107.09-.143.228-.07.3"
        fill="#c8b100" />
      <path
        d="M54.27 167.55c.071.072.216.054.318-.036.108-.09.144-.228.072-.3-.072-.078-.217-.06-.319.036-.107.09-.143.228-.07.3z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M66.438 167.4c.006-.006.228.288.396.438.114.108.402.198.402.198 0 .048-.168.168-.348.168a.337.337 0 01-.27-.12l-.024.12s-.144-.03-.216-.192c-.066-.174-.018-.432-.018-.432s.024-.12.078-.18"
        fill="#c8b100" />
      <path
        d="M66.438 167.4c.006-.006.228.288.396.438.114.108.402.198.402.198 0 .048-.168.168-.348.168a.337.337 0 01-.27-.12l-.024.12s-.144-.03-.216-.192c-.066-.174-.018-.432-.018-.432s.024-.12.078-.18z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M66.444 167.55c-.066.072-.21.054-.318-.036-.109-.09-.144-.228-.072-.3.072-.078.216-.06.324.036.108.09.138.228.066.3"
        fill="#c8b100" />
      <path
        d="M66.444 167.55c-.066.072-.21.054-.318-.036-.109-.09-.144-.228-.072-.3.072-.078.216-.06.324.036.108.09.138.228.066.3z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M53.748 160.578h13.374v3.504H53.748z"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M55.152 158.244a.546.546 0 00.246.042h10.014a.807.807 0 00.276-.048.841.841 0 00-.594.792c0 .367.27.684.618.798a1.159 1.159 0 00-.294-.048h-10.02a.846.846 0 00-.282.036l.054-.012a.787.787 0 00.564-.774.837.837 0 00-.582-.786"
        fill="#c8b100" />
      <path
        d="M55.152 158.244a.546.546 0 00.246.042h10.014a.807.807 0 00.276-.048.841.841 0 00-.594.792c0 .367.27.684.618.798a1.159 1.159 0 00-.294-.048h-10.02a.846.846 0 00-.282.036l.054-.012a.787.787 0 00.564-.774.837.837 0 00-.582-.786z"
        fill="none"
        stroke="#000"
        stroke-width=".234"
        stroke-linejoin="round" />
      <path
        d="M55.398 158.286h10.014c.342 0 .612-.21.612-.468 0-.264-.27-.474-.612-.474H55.398c-.336 0-.612.21-.612.474 0 .258.276.468.612.468"
        fill="#c8b100" />
      <path
        d="M55.398 158.286h10.014c.342 0 .612-.21.612-.468 0-.264-.27-.474-.612-.474H55.398c-.336 0-.612.21-.612.474 0 .258.276.468.612.468z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M55.398 160.578h10.02c.342 0 .618-.18.618-.396 0-.222-.276-.402-.618-.402h-10.02c-.336 0-.612.18-.612.402 0 .216.276.396.612.396"
        fill="#c8b100" />
      <path
        d="M55.398 160.578h10.02c.342 0 .618-.18.618-.396 0-.222-.276-.402-.618-.402h-10.02c-.336 0-.612.18-.612.402 0 .216.276.396.612.396z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M69.768 101.592c-.923 0-1.746.198-2.358.522-.6.307-1.415.492-2.315.492-.907 0-1.741-.192-2.347-.498-.606-.318-1.44-.516-2.351-.516-.925 0-1.752.216-2.36.54-.6.294-1.397.474-2.273.474-.912 0-1.716-.174-2.316-.485-.612-.324-1.451-.53-2.37-.53v-1.444c.919 0 1.758.209 2.37.527.6.312 1.404.492 2.316.492.87 0 1.674-.186 2.274-.48.607-.317 1.434-.54 2.359-.54.91 0 1.745.199 2.35.516.607.312 1.44.504 2.348.504.9 0 1.715-.192 2.315-.497.612-.324 1.422-.522 2.346-.522l.012 1.445"
        fill="#005bbf" />
      <path
        d="M69.768 101.592c-.923 0-1.746.198-2.358.522-.6.307-1.415.492-2.315.492-.907 0-1.741-.192-2.347-.498-.606-.318-1.44-.516-2.351-.516-.925 0-1.752.216-2.36.54-.6.294-1.397.474-2.273.474-.912 0-1.716-.174-2.316-.485-.612-.324-1.451-.53-2.37-.53v-1.444c.919 0 1.758.209 2.37.527.6.312 1.404.492 2.316.492.87 0 1.674-.186 2.274-.48.607-.317 1.434-.54 2.359-.54.91 0 1.745.199 2.35.516.607.312 1.44.504 2.348.504.9 0 1.715-.192 2.315-.497.612-.324 1.422-.522 2.346-.522z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M69.768 100.146c-.923 0-1.746.197-2.358.521-.6.307-1.415.5-2.315.5-.907 0-1.741-.193-2.347-.505-.606-.319-1.44-.516-2.351-.516-.925 0-1.752.221-2.36.54-.6.294-1.397.48-2.273.48-.912 0-1.716-.18-2.316-.492-.612-.318-1.451-.528-2.37-.528V98.7c.919 0 1.758.21 2.37.528.6.312 1.404.492 2.316.492.87 0 1.674-.186 2.274-.48.607-.324 1.434-.54 2.359-.54.91 0 1.745.204 2.35.516.607.312 1.44.504 2.348.504.9 0 1.715-.192 2.315-.504.612-.318 1.422-.516 2.346-.516l.012 1.446"
        fill="#ccc"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M69.768 98.7c-.923 0-1.746.198-2.358.516-.6.312-1.415.504-2.315.504-.907 0-1.741-.192-2.347-.504-.606-.312-1.44-.516-2.351-.516-.925 0-1.752.216-2.36.54-.6.294-1.397.48-2.273.48-.912 0-1.716-.18-2.316-.492-.612-.318-1.451-.528-2.37-.528v-1.44c.919 0 1.758.204 2.37.528.6.306 1.404.48 2.316.48.87 0 1.674-.18 2.274-.474.607-.324 1.434-.534 2.359-.534.91 0 1.745.192 2.35.51.607.312 1.44.498 2.348.498.9 0 1.715-.186 2.315-.492.612-.33 1.422-.516 2.346-.516l.012 1.44"
        fill="#005bbf"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M69.756 95.808c-.924 0-1.734.198-2.346.522-.6.306-1.416.492-2.316.492-.906 0-1.74-.186-2.346-.498-.606-.312-1.44-.516-2.352-.516-.924 0-1.752.222-2.358.54-.6.3-1.398.474-2.274.474-.912 0-1.716-.174-2.316-.486-.612-.318-1.452-.528-2.37-.528v1.44c.918 0 1.758.216 2.37.54.6.306 1.404.48 2.316.48.87 0 1.674-.18 2.274-.474.606-.324 1.434-.534 2.358-.534.912 0 1.746.192 2.352.51.606.312 1.44.498 2.346.498.9 0 1.716-.186 2.316-.492.612-.33 1.434-.516 2.358-.516l-.012-1.452"
        fill="#ccc"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M69.756 94.362c-.924 0-1.734.198-2.346.516-.6.312-1.416.504-2.316.504-.906 0-1.74-.192-2.346-.504-.606-.312-1.44-.516-2.352-.516-.924 0-1.752.222-2.358.54-.6.3-1.398.48-2.274.48-.912 0-1.716-.18-2.316-.492-.612-.318-1.452-.528-2.37-.528v1.434c.918 0 1.758.222 2.37.54.6.312 1.404.486 2.316.486.87 0 1.674-.18 2.274-.474.606-.318 1.434-.54 2.358-.54.912 0 1.746.204 2.352.516.606.312 1.44.498 2.346.498.9 0 1.716-.186 2.316-.492.612-.324 1.428-.522 2.358-.522l-.012-1.446"
        fill="#005bbf" />
      <path
        d="M69.756 94.362c-.924 0-1.734.198-2.346.516-.6.312-1.416.504-2.316.504-.906 0-1.74-.192-2.346-.504-.606-.312-1.44-.516-2.352-.516-.924 0-1.752.222-2.358.54-.6.3-1.398.48-2.274.48-.912 0-1.716-.18-2.316-.492-.612-.318-1.452-.528-2.37-.528v1.434c.918 0 1.758.222 2.37.54.6.312 1.404.486 2.316.486.87 0 1.674-.18 2.274-.474.606-.318 1.434-.54 2.358-.54.912 0 1.746.204 2.352.516.606.312 1.44.498 2.346.498.9 0 1.716-.186 2.316-.492.612-.324 1.428-.522 2.358-.522z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M55.152 107.532c.03-.126.078-.24.078-.372 0-.876-.762-1.578-1.686-1.578h13.764c-.93 0-1.686.702-1.686 1.578 0 .126.024.246.054.372a.76.76 0 00-.264-.036H55.398a.842.842 0 00-.246.036"
        fill="#c8b100" />
      <path
        d="M55.152 107.532c.03-.126.078-.24.078-.372 0-.876-.762-1.578-1.686-1.578h13.764c-.93 0-1.686.702-1.686 1.578 0 .126.024.246.054.372a.76.76 0 00-.264-.036H55.398a.842.842 0 00-.246.036z"
        fill="none"
        stroke="#000"
        stroke-width=".234"
        stroke-linejoin="round" />
      <path
        d="M55.398 108.438h10.014c.342 0 .612-.21.612-.468s-.27-.474-.612-.474H55.398c-.336 0-.612.216-.612.474s.276.468.612.468"
        fill="#c8b100" />
      <path
        d="M55.398 108.438h10.014c.342 0 .612-.21.612-.468s-.27-.474-.612-.474H55.398c-.336 0-.612.216-.612.474s.276.468.612.468z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M53.562 102.084h13.722v3.498H53.562z"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M52.488 120.828c-1.356-.78-2.28-1.584-2.13-1.986.072-.366.504-.642 1.122-1.05.972-.678 1.56-1.884 1.098-2.442.804.648 1.314 1.614 1.314 2.694 0 1.122-.54 2.136-1.404 2.784"
        fill="#ad1519" />
      <path
        d="M52.488 120.828c-1.356-.78-2.28-1.584-2.13-1.986.072-.366.504-.642 1.122-1.05.972-.678 1.56-1.884 1.098-2.442.804.648 1.314 1.614 1.314 2.694 0 1.122-.54 2.136-1.404 2.784z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path d="M55.53 109.008h9.75v47.778h-9.75z" fill="#ccc" />
      <path
        d="M63.576 156.72v-47.676m-1.098 47.677v-47.677M55.53 109.008h9.75v47.778h-9.75z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M75.24 138.918c-2.124.876-5.742 1.53-9.894 1.668a30.892 30.892 0 01-4.674-.42c-5.832-.978-10.278-3.306-9.924-5.202l.03-.156s-2.184 4.926-2.22 5.112c-.39 2.106 4.536 4.692 11.01 5.772 2.034.342 4.014.474 5.736.456 4.14 0 7.74-.534 9.912-1.338l.024-5.892"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".234"
        stroke-linejoin="round" />
      <path
        d="M55.512 132.918c-2.706.192-4.548.918-4.764 2.046-.168.9.75 1.902 2.382 2.808.726-.084 1.548-.18 2.4-.18l-.018-4.674M65.298 136.572c1.692-.258 2.958-.678 3.588-1.194l.06-.102c.3-.618-1.182-1.932-3.666-3.402l.018 4.698"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M49.452 123.702c-.258.768 2.382 2.316 6.108 3.684 1.704.606 3.108 1.242 4.854 2.01 5.178 2.292 9 4.92 8.532 5.874l-.054.102c.276-.228.708-4.944.708-4.944.468-.876-3.03-3.468-7.8-5.748-1.524-.732-4.746-1.92-6.264-2.454-2.724-.942-5.424-2.724-5.178-3.384l-.906 4.854"
        fill="#ad1519" />
      <path
        d="M49.452 123.702c-.258.768 2.382 2.316 6.108 3.684 1.704.606 3.108 1.242 4.854 2.01 5.178 2.292 9 4.92 8.532 5.874l-.054.102c.276-.228.708-4.944.708-4.944.468-.876-3.03-3.468-7.8-5.748-1.524-.732-4.746-1.92-6.264-2.454-2.724-.942-5.424-2.724-5.178-3.384l-.906 4.854z"
        fill="none"
        stroke="#000"
        stroke-width=".234"
        stroke-linejoin="round" />
      <path
        d="M54.144 142.956l.414.15c.342.126.726-.06.9-.48.126-.318.096-.678-.3-.93-.126-.078-.276-.138-.42-.198l-.594 1.458m.708-1.746c1.194.432 1.974.948 1.596 1.884-.246.6-.858.714-1.782.378l-1.626-.594 1.464-3.618c.162.072.324.144.486.204.168.06.342.108.51.156l-.648 1.584zM58.668 144.468c-.173-.047-.342-.096-.516-.132a7.963 7.963 0 00-.528-.072l.847-3.767 2.627.527c-.03.073-.072.156-.084.228-.017.084-.017.169-.024.246-.462-.132-.966-.276-1.566-.396l-.756 3.366M63.936 141.222c.492 1.368 1.092 2.676 1.686 4.002a2.992 2.992 0 00-.324-.042 2.918 2.918 0 00-.324 0 33.963 33.963 0 00-1.122-2.88c-.492.906-1.038 1.794-1.458 2.706-.204-.024-.414-.054-.618-.072-.204-.012-.42-.006-.624-.012a89.306 89.306 0 002.184-3.738c.096.018.192.036.3.048.096.006.198-.006.3-.012M69.432 144.12c.09.186.186.36.288.534-.144.132-.576.33-1.086.378-1.074.108-1.686-.366-1.758-1.015-.156-1.355 1.986-1.24 1.884-2.14-.042-.386-.45-.54-.888-.499-.486.048-.846.318-.906.713l-.132.013a4.502 4.502 0 00-.288-.69c.318-.204.726-.318 1.11-.354 1.098-.114 1.932.324 2.01 1.044.138 1.29-2.022 1.362-1.938 2.124.036.318.282.528.84.474.402-.042.648-.258.756-.57l.108-.012"
        fill="#c8b100" />
      <path
        d="M149.91 167.748s-.444-.468-.768-.534c-.318-.06-.726.294-.726.294s-.288-.306-.648-.384c-.354-.084-.846.396-.846.396s-.342-.48-.642-.594c-.306-.108-.678.144-.678.144s-.138-.234-.39-.366c-.108-.054-.288.03-.288.03l-.36.228-.408.432-.372.144s-.168.546-.186.642a26.04 26.04 0 01-.048.342c-.078.39.522.84 1.38 1.032.492.114.924.108 1.236.012.342.288 1.068.492 1.92.492.774 0 1.452-.162 1.824-.42.366.258 1.044.42 1.818.42.852 0 1.572-.204 1.914-.492.318.096.744.102 1.242-.012.852-.192 1.458-.642 1.38-1.032 0 0-.036-.246-.048-.342-.018-.096-.192-.642-.192-.642l-.372-.144-.408-.432-.348-.228s-.18-.084-.288-.03c-.258.126-.396.366-.396.366s-.372-.252-.678-.144c-.306.114-.642.594-.642.594s-.492-.48-.852-.396c-.354.078-.642.384-.642.384s-.408-.354-.726-.294c-.324.066-.762.534-.762.534"
        fill="#ad1519" />
      <path
        d="M149.91 167.748s-.444-.468-.768-.534c-.318-.06-.726.294-.726.294s-.288-.306-.648-.384c-.354-.084-.846.396-.846.396s-.342-.48-.642-.594c-.306-.108-.678.144-.678.144s-.138-.234-.39-.366c-.108-.054-.288.03-.288.03l-.36.228-.408.432-.372.144s-.168.546-.186.642a26.04 26.04 0 01-.048.342c-.078.39.522.84 1.38 1.032.492.114.924.108 1.236.012.342.288 1.068.492 1.92.492.774 0 1.452-.162 1.824-.42.366.258 1.044.42 1.818.42.852 0 1.572-.204 1.914-.492.318.096.744.102 1.242-.012.852-.192 1.458-.642 1.38-1.032 0 0-.036-.246-.048-.342-.018-.096-.192-.642-.192-.642l-.372-.144-.408-.432-.348-.228s-.18-.084-.288-.03c-.258.126-.396.366-.396.366s-.372-.252-.678-.144c-.306.114-.642.594-.642.594s-.492-.48-.852-.396c-.354.078-.642.384-.642.384s-.408-.354-.726-.294c-.324.066-.762.534-.762.534z"
        fill="none"
        stroke="#000"
        stroke-width=".162" />
      <path
        d="M149.07 170.28c0 .654.366 1.176.822 1.176.456 0 .828-.522.828-1.176 0-.648-.372-1.176-.828-1.176-.456 0-.822.528-.822 1.176"
        fill="#c8b100" />
      <path
        d="M149.07 170.28c0 .654.366 1.176.822 1.176.456 0 .828-.522.828-1.176 0-.648-.372-1.176-.828-1.176-.456 0-.822.528-.822 1.176z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M149.532 170.28c0 .6.168 1.086.378 1.086s.378-.486.378-1.086c0-.6-.168-1.08-.378-1.08s-.378.48-.378 1.08"
        fill="#c8b100" />
      <path
        d="M149.532 170.28c0 .6.168 1.086.378 1.086s.378-.486.378-1.086c0-.6-.168-1.08-.378-1.08s-.378.48-.378 1.08z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M145.65 165.45a3.009 3.009 0 01-.354.648c1.17.342 2.796.558 4.608.564 1.806-.006 3.443-.222 4.614-.564 0 0-.132-.228-.312-.546a3.957 3.957 0 01-.228-.486c-1.057.324-2.412.486-4.081.492-1.674-.006-3.281-.21-4.115-.516.012 0-.061.192-.144.408h.012"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M149.904 163.962c1.458.006 3.066.228 3.66.378.396.12.624.294.582.504-.018.096-.102.18-.222.228-.87.282-2.436.48-4.02.48-1.584 0-3.162-.198-4.032-.48-.114-.048-.204-.132-.222-.228-.042-.21.192-.384.588-.504.594-.15 2.208-.372 3.666-.378"
        fill="#c8b100" />
      <path
        d="M149.904 163.962c1.458.006 3.066.228 3.66.378.396.12.624.294.582.504-.018.096-.102.18-.222.228-.87.282-2.436.48-4.02.48-1.584 0-3.162-.198-4.032-.48-.114-.048-.204-.132-.222-.228-.042-.21.192-.384.588-.504.594-.15 2.208-.372 3.666-.378z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M153.444 169.752c0 .144.12.264.264.264a.27.27 0 00.276-.264c0-.138-.12-.252-.276-.252a.26.26 0 00-.264.252"
        fill="#fff" />
      <path
        d="M153.444 169.752c0 .144.12.264.264.264a.27.27 0 00.276-.264c0-.138-.12-.252-.276-.252a.26.26 0 00-.264.252zM150.9 171.456c0 .144.12.258.264.258.156 0 .276-.114.276-.258 0-.144-.12-.252-.276-.252a.256.256 0 00-.264.252zm.858.03c0 .144.126.264.276.264.15 0 .27-.12.27-.264 0-.138-.12-.252-.27-.252-.15 0-.276.114-.276.252zm.852-.27c0 .144.12.258.27.258.15 0 .27-.114.27-.258a.263.263 0 00-.27-.258c-.15 0-.27.114-.27.258zm.678-.564c0 .144.12.258.27.258.15 0 .27-.114.27-.258 0-.138-.12-.252-.27-.252-.15 0-.27.114-.27.252z"
        fill="none"
        stroke="#000"
        stroke-width=".126" />
      <path
        d="M156.126 168.006c.078.198.126.42.126.648 0 .954-.756 1.728-1.692 1.728-.3 0-.582-.078-.828-.222"
        fill="none"
        stroke="#000"
        stroke-width=".156"
        stroke-linecap="round" />
      <path
        d="M153.102 169.224c.09.156.15.342.15.522 0 .69-.708 1.248-1.584 1.248-.372 0-.714-.102-.984-.27"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M153.966 170.814c0 .144.12.258.27.258.15 0 .276-.114.276-.258 0-.138-.126-.258-.276-.258-.15 0-.27.12-.27.258zm.864.036c0 .138.126.252.276.252.15 0 .27-.114.27-.252a.268.268 0 00-.27-.264c-.15 0-.276.12-.276.264zm.816-.39c0 .144.12.258.27.258.15 0 .27-.114.27-.258 0-.138-.12-.252-.27-.252-.15 0-.27.114-.27.252zm.606-.72c0 .144.126.252.276.252.15 0 .27-.108.27-.252a.263.263 0 00-.27-.258c-.15 0-.276.114-.276.258zm.108-.948c0 .144.12.258.27.258.15 0 .27-.114.27-.258a.263.263 0 00-.27-.258c-.15 0-.27.114-.27.258z"
        fill="none"
        stroke="#000"
        stroke-width=".126" />
      <path
        d="M154.59 166.752l-.354.318s-.342-.204-.768-.144c-.42.066-.558.582-.558.582s-.474-.402-.864-.372c-.39.036-.642.372-.642.372s-.426-.306-.798-.276c-.372.036-.732.498-.732.498s-.372-.48-.744-.516c-.372-.03-.678.324-.678.324s-.174-.354-.648-.432c-.474-.078-.882.372-.882.372s-.264-.438-.588-.552c-.324-.108-.744.162-.744.162s-.072-.162-.12-.258c-.054-.096-.186-.114-.186-.114l.102-.282c1.164.336 2.742.546 4.524.546s3.402-.21 4.56-.552l.12.324"
        fill="#c8b100" />
      <path
        d="M154.59 166.752l-.354.318s-.342-.204-.768-.144c-.42.066-.558.582-.558.582s-.474-.402-.864-.372c-.39.036-.642.372-.642.372s-.426-.306-.798-.276c-.372.036-.732.498-.732.498s-.372-.48-.744-.516c-.372-.03-.678.324-.678.324s-.174-.354-.648-.432c-.474-.078-.882.372-.882.372s-.264-.438-.588-.552c-.324-.108-.744.162-.744.162s-.072-.162-.12-.258c-.054-.096-.186-.114-.186-.114l.102-.282c1.164.336 2.742.546 4.524.546s3.402-.21 4.56-.552z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M145.788 169.752c0 .144.12.264.27.264.15 0 .27-.12.27-.264 0-.138-.12-.252-.27-.252-.15 0-.27.114-.27.252"
        fill="#fff" />
      <path
        d="M145.788 169.752c0 .144.12.264.27.264.15 0 .27-.12.27-.264 0-.138-.12-.252-.27-.252-.15 0-.27.114-.27.252zM148.332 171.456c0 .144.12.258.27.258.15 0 .27-.114.27-.258 0-.144-.12-.252-.27-.252-.15 0-.27.108-.27.252zm-.87.03c0 .144.126.264.276.264.15 0 .27-.12.27-.264 0-.138-.12-.252-.27-.252-.15 0-.276.114-.276.252zm-.846-.27c0 .144.12.258.27.258.15 0 .276-.114.276-.258 0-.144-.126-.258-.276-.258-.15 0-.27.114-.27.258zm-.678-.564c0 .144.12.258.27.258.15 0 .276-.114.276-.258 0-.138-.126-.252-.276-.252-.15 0-.27.114-.27.252z"
        fill="none"
        stroke="#000"
        stroke-width=".126" />
      <path
        d="M143.645 168.006c-.078.198-.132.42-.132.648 0 .954.756 1.728 1.698 1.728.3 0 .576-.078.822-.222"
        fill="none"
        stroke="#000"
        stroke-width=".156"
        stroke-linecap="round" />
      <path
        d="M146.688 169.242c-.09.156-.174.324-.174.505 0 .689.714 1.247 1.584 1.247.372 0 .72-.102.99-.27"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M145.26 170.814c0 .144.12.258.27.258.15 0 .27-.114.27-.258a.267.267 0 00-.27-.258c-.15 0-.27.12-.27.258zm-.864.036c0 .138.12.252.27.252.15 0 .27-.114.27-.252a.268.268 0 00-.27-.264c-.15 0-.27.12-.27.264zm-.816-.39c0 .144.12.258.276.258.144 0 .27-.114.27-.258 0-.138-.126-.252-.27-.252-.156 0-.276.114-.276.252zm-.612-.72c0 .144.126.252.276.252.15 0 .27-.108.27-.252a.263.263 0 00-.27-.258c-.15 0-.276.114-.276.258zm-.102-.948c0 .144.126.258.276.258.144 0 .27-.114.27-.258 0-.144-.126-.258-.27-.258-.15 0-.276.114-.276.258z"
        fill="none"
        stroke="#000"
        stroke-width=".126" />
      <path
        d="M149.91 168.306l.168-.03a.7.7 0 01-.03-.228c0-.348.3-.63.672-.63.294 0 .546.186.63.438.012-.006.066.228.096.228.024 0 .018-.246.024-.246.042-.318.336-.534.666-.534.366 0 .666.282.666.636 0 .024 0 .048-.006.072l.21.21.114-.264a.537.537 0 01-.066-.276c0-.336.288-.606.642-.606.222 0 .414.108.528.27l.138.174-.006-.216c0-.204.09-.396.294-.426 0 0 .24-.018.546.228.318.246.486.45.486.45l.018-.252s-.306-.504-.582-.66c-.15-.09-.384-.186-.57-.15-.198.03-.33.186-.408.366a.908.908 0 00-.474-.132c-.378 0-.72.21-.852.516a.98.98 0 00-1.452.048.977.977 0 00-1.458.156.966.966 0 00-.798-.414.941.941 0 00-.654.258.984.984 0 00-.756-.348.936.936 0 00-.696.3c-.132-.306-.474-.516-.852-.516a.908.908 0 00-.474.132c-.072-.18-.21-.336-.408-.366-.18-.036-.414.06-.564.15-.282.156-.612.66-.612.66l.042.252s.168-.204.48-.45c.312-.246.552-.228.552-.228.204.03.288.222.288.426v.216l.138-.174a.642.642 0 01.528-.27c.354 0 .642.27.642.606a.537.537 0 01-.066.276l.114.264.21-.21c-.006-.024-.006-.048-.006-.072 0-.354.3-.636.66-.636.336 0 .624.216.666.534.012 0 .006.246.03.246.03 0 .084-.234.09-.228a.677.677 0 01.642-.438c.366 0 .666.282.666.63a.7.7 0 01-.03.228l.174.03"
        fill="#c8b100" />
      <path
        d="M149.91 168.306l.168-.03a.7.7 0 01-.03-.228c0-.348.3-.63.672-.63.294 0 .546.186.63.438.012-.006.066.228.096.228.024 0 .018-.246.024-.246.042-.318.336-.534.666-.534.366 0 .666.282.666.636 0 .024 0 .048-.006.072l.21.21.114-.264a.537.537 0 01-.066-.276c0-.336.288-.606.642-.606.222 0 .414.108.528.27l.138.174-.006-.216c0-.204.09-.396.294-.426 0 0 .24-.018.546.228.318.246.486.45.486.45l.018-.252s-.306-.504-.582-.66c-.15-.09-.384-.186-.57-.15-.198.03-.33.186-.408.366a.908.908 0 00-.474-.132c-.378 0-.72.21-.852.516a.98.98 0 00-1.452.048.977.977 0 00-1.458.156.966.966 0 00-.798-.414.941.941 0 00-.654.258.984.984 0 00-.756-.348.936.936 0 00-.696.3c-.132-.306-.474-.516-.852-.516a.908.908 0 00-.474.132c-.072-.18-.21-.336-.408-.366-.18-.036-.414.06-.564.15-.282.156-.612.66-.612.66l.042.252s.168-.204.48-.45c.312-.246.552-.228.552-.228.204.03.288.222.288.426v.216l.138-.174a.642.642 0 01.528-.27c.354 0 .642.27.642.606a.537.537 0 01-.066.276l.114.264.21-.21c-.006-.024-.006-.048-.006-.072 0-.354.3-.636.66-.636.336 0 .624.216.666.534.012 0 .006.246.03.246.03 0 .084-.234.09-.228a.677.677 0 01.642-.438c.366 0 .666.282.666.63a.7.7 0 01-.03.228z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M149.904 166.662c-1.812-.006-3.432-.222-4.602-.564-.078-.024-.174.036-.198.102-.024.078.03.168.108.192 1.17.36 2.838.588 4.692.588 1.848 0 3.522-.228 4.698-.588.078-.024.132-.114.108-.192-.024-.066-.126-.126-.198-.102-1.17.342-2.802.558-4.608.564"
        fill="#c8b100" />
      <path
        d="M149.904 166.662c-1.812-.006-3.432-.222-4.602-.564-.078-.024-.174.036-.198.102-.024.078.03.168.108.192 1.17.36 2.838.588 4.692.588 1.848 0 3.522-.228 4.698-.588.078-.024.132-.114.108-.192-.024-.066-.126-.126-.198-.102-1.17.342-2.802.558-4.608.564z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M148.152 166.02c0 .132.12.246.264.246.144 0 .264-.114.264-.246 0-.138-.12-.246-.264-.246-.144 0-.264.108-.264.246"
        fill="#fff" />
      <path
        d="M148.152 166.02c0 .132.12.246.264.246.144 0 .264-.114.264-.246 0-.138-.12-.246-.264-.246-.144 0-.264.108-.264.246z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M149.928 165.912h-.588c-.108 0-.198.084-.198.186s.09.186.198.186h1.176a.188.188 0 00.192-.186.188.188 0 00-.192-.186h-.588"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M147.012 165.714l-.42-.066c-.108-.012-.204.054-.222.156-.018.102.054.192.162.21l.414.06.432.066c.102.012.204-.054.222-.15a.189.189 0 00-.168-.21l-.42-.066"
        fill="#058e6e"
        stroke="#000"
        stroke-width=".156" />
      <path d="M145.332 165.42l.18.3.396-.079-.228-.335z" fill="#ad1519" />
      <path
        d="M145.332 165.42l.18.3.396-.079-.228-.335-.348.114"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M151.134 166.02c0 .132.114.246.258.246.144 0 .264-.114.264-.246 0-.138-.12-.246-.264-.246a.25.25 0 00-.258.246"
        fill="#fff" />
      <path
        d="M151.134 166.02c0 .132.114.246.258.246.144 0 .264-.114.264-.246 0-.138-.12-.246-.264-.246a.25.25 0 00-.258.246z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M152.796 165.714l.42-.066c.107-.012.203.054.221.156.018.102-.054.192-.156.21l-.42.06-.425.066c-.108.012-.21-.054-.228-.15a.189.189 0 01.168-.21l.42-.066"
        fill="#058e6e"
        stroke="#000"
        stroke-width=".156" />
      <path d="M154.446 165.402l-.15.318-.408-.036.198-.354z" fill="#ad1519" />
      <path
        d="M154.446 165.402l-.15.318-.408-.036.198-.354.36.072"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M149.898 164.304c-1.458 0-2.778.132-3.786.39 1.008.258 2.328.414 3.786.42 1.464 0 2.79-.162 3.792-.42-1.002-.258-2.328-.39-3.792-.39"
        fill="#ad1519" />
      <path
        d="M149.898 164.304c-1.458 0-2.778.132-3.786.39 1.008.258 2.328.414 3.786.42 1.464 0 2.79-.162 3.792-.42-1.002-.258-2.328-.39-3.792-.39z"
        fill="none"
        stroke="#000"
        stroke-width=".156"
        stroke-linejoin="round" />
      <path
        d="M154.506 167.472c.036.108 0 .222-.084.252-.078.018-.174-.054-.21-.162-.042-.114-.006-.228.072-.252.084-.024.18.048.222.162"
        fill="#c8b100" />
      <path
        d="M154.506 167.472c.036.108 0 .222-.084.252-.078.018-.174-.054-.21-.162-.042-.114-.006-.228.072-.252.084-.024.18.048.222.162z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M151.595 168.03c.018.12-.042.222-.126.234-.084.012-.168-.078-.18-.198-.018-.114.042-.222.126-.228.084-.012.168.078.18.192"
        fill="#c8b100" />
      <path
        d="M151.595 168.03c.018.12-.042.222-.126.234-.084.012-.168-.078-.18-.198-.018-.114.042-.222.126-.228.084-.012.168.078.18.192z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M148.223 168.03c-.018.12.036.222.127.234.083.012.161-.078.18-.198.011-.114-.043-.222-.127-.228-.084-.012-.168.078-.18.192"
        fill="#c8b100" />
      <path
        d="M148.223 168.03c-.018.12.036.222.127.234.083.012.161-.078.18-.198.011-.114-.043-.222-.127-.228-.084-.012-.168.078-.18.192z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M145.314 167.472c-.042.108 0 .222.078.252.078.018.18-.054.216-.162.042-.114.006-.228-.072-.252-.084-.024-.18.048-.222.162"
        fill="#c8b100" />
      <path
        d="M145.314 167.472c-.042.108 0 .222.078.252.078.018.18-.054.216-.162.042-.114.006-.228-.072-.252-.084-.024-.18.048-.222.162z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M149.898 169.71l-.51-.312.378-.828.132-.084.132.084.384.828z" fill="#c8b100" />
      <path
        d="M149.898 169.71l-.51-.312.378-.828.132-.084.132.084.384.828-.516.312"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M148.77 168.456l.233-.342.805.252.084.108-.084.12-.804.234z" fill="#c8b100" />
      <path
        d="M148.77 168.456l.233-.342.805.252.084.108-.084.12-.804.234-.234-.372"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M151.032 168.456l-.234-.342-.804.252-.084.108.084.12.804.234z" fill="#c8b100" />
      <path
        d="M151.032 168.456l-.234-.342-.804.252-.084.108.084.12.804.234.234-.372"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M146.55 169.344l-.403-.384.517-.684.138-.054.102.108.18.822-.535.192"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".156" />
      <path d="M145.704 167.976l.3-.288.738.396.054.126-.108.102-.834.072z" fill="#c8b100" />
      <path
        d="M145.704 167.976l.3-.288.738.396.054.126-.108.102-.834.072-.15-.408"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M147.918 168.42l-.156-.379-.84.08-.108.095.054.132.738.384z" fill="#c8b100" />
      <path
        d="M147.918 168.42l-.156-.379-.84.08-.108.095.054.132.738.384.312-.312"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M144.894 167.868l-.066-.396-.84-.09-.132.072.036.138.63.522z" fill="#c8b100" />
      <path
        d="M144.894 167.868l-.066-.396-.84-.09-.132.072.036.138.63.522.372-.246"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M146.514 168.21c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276"
        fill="#c8b100" />
      <path
        d="M146.514 168.21c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M153.264 169.344l.402-.384-.516-.684-.138-.054-.102.108-.18.822z" fill="#c8b100" />
      <path
        d="M153.264 169.344l.402-.384-.516-.684-.138-.054-.102.108-.18.822.534.192"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M154.11 167.976l-.306-.288-.732.396-.06.126.108.102.84.072z" fill="#c8b100" />
      <path
        d="M154.11 167.976l-.306-.288-.732.396-.06.126.108.102.84.072.15-.408"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M151.895 168.42l.156-.379.84.08.109.095-.06.132-.732.384z" fill="#c8b100" />
      <path
        d="M151.895 168.42l.156-.379.84.08.109.095-.06.132-.732.384-.312-.312"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M154.806 167.868l.066-.396.84-.09.126.072-.03.138-.63.522z" fill="#c8b100" />
      <path
        d="M154.806 167.868l.066-.396.84-.09.126.072-.03.138-.63.522-.372-.246"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M149.61 168.474c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276"
        fill="#c8b100" />
      <path
        d="M149.61 168.474c0 .156.132.282.294.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.294.126-.294.276z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M152.712 168.21c0 .156.138.282.3.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.3.126-.3.276"
        fill="#c8b100" />
      <path
        d="M152.712 168.21c0 .156.138.282.3.282a.288.288 0 00.294-.282c0-.15-.132-.276-.294-.276-.162 0-.3.126-.3.276z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M149.352 171.63c0 .288.246.522.552.522.306 0 .558-.234.558-.522 0-.294-.252-.528-.558-.528a.538.538 0 00-.552.528"
        fill="#c8b100" />
      <path
        d="M150.294 171.816v-.348h-.852v.348h.282v.78h-.372v.348h.372v.348h.366v-.348h.36v-.348h-.36v-.78z"
        fill="#c8b100" />
      <path
        d="M150.294 171.816v-.348h-.852v.348h.282v.78h-.372v.348h.372v.348h.366v-.348h.36v-.348h-.36v-.78z"
        fill="none"
        stroke="#000"
        stroke-width=".18" />
      <path
        d="M150.678 171.816v-.348h-1.518v.348h.564v.78h-.372v.348h.372v.348h.366v-.348h.366v-.348h-.366v-.78z"
        fill="#c8b100" />
      <path
        d="M150.066 172.128a.524.524 0 00.396-.498c0-.294-.246-.528-.558-.528a.538.538 0 00-.552.528c0 .24.174.444.408.504"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M143.76 167.4c-.006-.006-.228.288-.396.438-.114.108-.402.198-.402.198 0 .048.168.168.348.168.108 0 .21-.042.27-.12l.018.12s.15-.03.216-.192c.066-.174.024-.432.024-.432s-.03-.12-.078-.18"
        fill="#c8b100" />
      <path
        d="M143.76 167.4c-.006-.006-.228.288-.396.438-.114.108-.402.198-.402.198 0 .048.168.168.348.168.108 0 .21-.042.27-.12l.018.12s.15-.03.216-.192c.066-.174.024-.432.024-.432s-.03-.12-.078-.18z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M143.772 167.55c.066.072.21.054.318-.036.108-.09.138-.228.066-.3-.066-.078-.21-.06-.318.036-.108.09-.138.228-.066.3"
        fill="#c8b100" />
      <path
        d="M143.772 167.55c.066.072.21.054.318-.036.108-.09.138-.228.066-.3-.066-.078-.21-.06-.318.036-.108.09-.138.228-.066.3z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M155.94 167.4c.006-.006.228.288.39.438.12.108.408.198.408.198 0 .048-.168.168-.354.168a.334.334 0 01-.264-.12l-.024.12s-.15-.03-.216-.192c-.066-.174-.024-.432-.024-.432s.03-.12.084-.18"
        fill="#c8b100" />
      <path
        d="M155.94 167.4c.006-.006.228.288.39.438.12.108.408.198.408.198 0 .048-.168.168-.354.168a.334.334 0 01-.264-.12l-.024.12s-.15-.03-.216-.192c-.066-.174-.024-.432-.024-.432s.03-.12.084-.18z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M155.946 167.55c-.072.072-.216.054-.324-.036-.109-.09-.139-.228-.067-.3.066-.078.21-.06.318.036.109.09.145.228.073.3"
        fill="#c8b100" />
      <path
        d="M155.946 167.55c-.072.072-.216.054-.324-.036-.109-.09-.139-.228-.067-.3.066-.078.21-.06.318.036.109.09.145.228.073.3z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M143.226 160.578H156.6v3.504h-13.374z"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M155.196 158.244a.546.546 0 01-.246.042h-10.014a.807.807 0 01-.277-.048.843.843 0 01.588.792c0 .367-.264.684-.612.798.084-.024.192-.048.294-.048h10.02c.102 0 .198.006.282.036l-.06-.012a.79.79 0 01-.557-.774.83.83 0 01.582-.786"
        fill="#c8b100" />
      <path
        d="M155.196 158.244a.546.546 0 01-.246.042h-10.014a.807.807 0 01-.277-.048.843.843 0 01.588.792c0 .367-.264.684-.612.798.084-.024.192-.048.294-.048h10.02c.102 0 .198.006.282.036l-.06-.012a.79.79 0 01-.557-.774.83.83 0 01.582-.786z"
        fill="none"
        stroke="#000"
        stroke-width=".234"
        stroke-linejoin="round" />
      <path
        d="M144.936 158.286h10.014c.336 0 .612-.21.612-.468 0-.264-.276-.474-.612-.474h-10.014c-.342 0-.612.21-.612.474 0 .258.27.468.612.468"
        fill="#c8b100" />
      <path
        d="M144.936 158.286h10.014c.336 0 .612-.21.612-.468 0-.264-.276-.474-.612-.474h-10.014c-.342 0-.612.21-.612.474 0 .258.27.468.612.468z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M144.93 160.578h10.02c.336 0 .612-.18.612-.396 0-.222-.276-.402-.612-.402h-10.02c-.342 0-.618.18-.618.402 0 .216.276.396.618.396"
        fill="#c8b100" />
      <path
        d="M144.93 160.578h10.02c.336 0 .612-.18.612-.396 0-.222-.276-.402-.612-.402h-10.02c-.342 0-.618.18-.618.402 0 .216.276.396.618.396z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M140.58 101.592c.924 0 1.746.198 2.352.522.606.307 1.422.492 2.322.492.906 0 1.74-.192 2.346-.498.6-.318 1.44-.516 2.352-.516.924 0 1.752.216 2.358.54.6.294 1.398.474 2.274.474.912 0 1.71-.174 2.316-.485.606-.324 1.452-.53 2.37-.53v-1.444c-.918 0-1.764.209-2.37.527-.606.312-1.404.492-2.316.492-.876 0-1.674-.186-2.274-.48-.606-.317-1.434-.54-2.358-.54-.912 0-1.746.199-2.352.516-.606.312-1.44.504-2.346.504-.9 0-1.716-.192-2.322-.497-.606-.324-1.416-.522-2.34-.522l-.012 1.445"
        fill="#005bbf" />
      <path
        d="M140.58 101.592c.924 0 1.746.198 2.352.522.606.307 1.422.492 2.322.492.906 0 1.74-.192 2.346-.498.6-.318 1.44-.516 2.352-.516.924 0 1.752.216 2.358.54.6.294 1.398.474 2.274.474.912 0 1.71-.174 2.316-.485.606-.324 1.452-.53 2.37-.53v-1.444c-.918 0-1.764.209-2.37.527-.606.312-1.404.492-2.316.492-.876 0-1.674-.186-2.274-.48-.606-.317-1.434-.54-2.358-.54-.912 0-1.746.199-2.352.516-.606.312-1.44.504-2.346.504-.9 0-1.716-.192-2.322-.497-.606-.324-1.416-.522-2.34-.522z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M140.58 100.146c.924 0 1.746.197 2.352.521.606.307 1.422.5 2.322.5.906 0 1.74-.193 2.346-.505.6-.319 1.44-.516 2.352-.516.924 0 1.752.221 2.358.54.6.294 1.398.48 2.274.48.912 0 1.71-.18 2.316-.492.606-.318 1.452-.528 2.37-.528V98.7c-.918 0-1.764.21-2.37.528-.606.312-1.404.492-2.316.492-.876 0-1.674-.186-2.274-.48-.606-.324-1.434-.54-2.358-.54-.912 0-1.746.204-2.352.516-.606.312-1.44.504-2.346.504-.9 0-1.716-.192-2.322-.504-.606-.318-1.416-.516-2.34-.516l-.012 1.446"
        fill="#ccc"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M140.58 98.7c.924 0 1.746.198 2.352.516.606.312 1.422.504 2.322.504.906 0 1.74-.192 2.346-.504.6-.312 1.44-.516 2.352-.516.924 0 1.752.216 2.358.54.6.294 1.398.48 2.274.48.912 0 1.71-.18 2.316-.492.606-.318 1.452-.528 2.37-.528v-1.44c-.918 0-1.764.204-2.37.528-.606.306-1.404.48-2.316.48-.876 0-1.674-.18-2.274-.474-.606-.324-1.434-.534-2.358-.534-.912 0-1.746.192-2.352.51-.606.312-1.44.498-2.346.498-.9 0-1.716-.186-2.322-.492-.606-.33-1.416-.516-2.34-.516l-.012 1.44"
        fill="#005bbf"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M140.592 95.808c.924 0 1.734.198 2.34.522.606.306 1.422.492 2.322.492.906 0 1.74-.186 2.346-.498.6-.312 1.44-.516 2.352-.516.924 0 1.752.222 2.358.54.6.3 1.398.474 2.274.474.912 0 1.71-.174 2.316-.486.606-.318 1.452-.528 2.37-.528v1.44c-.918 0-1.764.216-2.37.54-.606.306-1.404.48-2.316.48-.876 0-1.674-.18-2.274-.474-.606-.324-1.434-.534-2.358-.534-.912 0-1.746.192-2.352.51-.606.312-1.44.498-2.346.498-.9 0-1.716-.186-2.322-.492-.606-.33-1.428-.516-2.352-.516l.012-1.452"
        fill="#ccc"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M140.592 94.362c.924 0 1.734.198 2.34.516.606.312 1.422.504 2.322.504.906 0 1.74-.192 2.346-.504.6-.312 1.44-.516 2.352-.516.924 0 1.752.222 2.358.54.6.3 1.398.48 2.274.48.912 0 1.71-.18 2.316-.492.606-.318 1.452-.528 2.37-.528v1.434c-.918 0-1.764.222-2.37.54-.606.312-1.404.486-2.316.486-.876 0-1.674-.18-2.274-.474-.606-.318-1.434-.54-2.358-.54-.912 0-1.746.204-2.352.516-.606.312-1.44.498-2.346.498-.9 0-1.716-.186-2.322-.492-.606-.324-1.428-.522-2.352-.522l.012-1.446"
        fill="#005bbf" />
      <path
        d="M140.592 94.362c.924 0 1.734.198 2.34.516.606.312 1.422.504 2.322.504.906 0 1.74-.192 2.346-.504.6-.312 1.44-.516 2.352-.516.924 0 1.752.222 2.358.54.6.3 1.398.48 2.274.48.912 0 1.71-.18 2.316-.492.606-.318 1.452-.528 2.37-.528v1.434c-.918 0-1.764.222-2.37.54-.606.312-1.404.486-2.316.486-.876 0-1.674-.18-2.274-.474-.606-.318-1.434-.54-2.358-.54-.912 0-1.746.204-2.352.516-.606.312-1.44.498-2.346.498-.9 0-1.716-.186-2.322-.492-.606-.324-1.428-.522-2.352-.522z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M155.196 107.532c-.036-.126-.078-.24-.078-.372 0-.876.762-1.578 1.686-1.578H143.04c.93 0 1.686.702 1.686 1.578 0 .126-.024.246-.054.372a.722.722 0 01.264-.036h10.008c.084 0 .18.012.246.036"
        fill="#c8b100" />
      <path
        d="M155.196 107.532c-.036-.126-.078-.24-.078-.372 0-.876.762-1.578 1.686-1.578H143.04c.93 0 1.686.702 1.686 1.578 0 .126-.024.246-.054.372a.722.722 0 01.264-.036h10.008c.084 0 .18.012.246.036z"
        fill="none"
        stroke="#000"
        stroke-width=".234"
        stroke-linejoin="round" />
      <path
        d="M144.936 108.438h10.014c.336 0 .612-.21.612-.468s-.276-.474-.612-.474h-10.014c-.342 0-.612.216-.612.474s.27.468.612.468"
        fill="#c8b100" />
      <path
        d="M144.936 108.438h10.014c.336 0 .612-.21.612-.468s-.276-.474-.612-.474h-10.014c-.342 0-.612.216-.612.474s.27.468.612.468z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M143.058 102.084h13.728v3.498h-13.728z"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M157.86 120.828c1.356-.78 2.28-1.584 2.13-1.986-.072-.366-.504-.642-1.122-1.05-.972-.678-1.56-1.884-1.098-2.442a3.449 3.449 0 00.09 5.478"
        fill="#ad1519" />
      <path
        d="M157.86 120.828c1.356-.78 2.28-1.584 2.13-1.986-.072-.366-.504-.642-1.122-1.05-.972-.678-1.56-1.884-1.098-2.442a3.449 3.449 0 00.09 5.478z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path d="M145.068 109.008h9.75v47.778h-9.75z" fill="#ccc" />
      <path
        d="M153.24 156.804v-47.676m-1.098 47.676v-47.676M145.068 109.008h9.75v47.778h-9.75z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M135.102 138.918c2.13.876 5.748 1.53 9.9 1.668a30.892 30.892 0 004.674-.42c5.832-.978 10.272-3.306 9.924-5.202-.012-.036-.024-.12-.03-.156 0 0 2.184 4.926 2.22 5.112.39 2.106-4.536 4.692-11.01 5.772-2.034.342-4.02.474-5.736.456-4.146 0-7.746-.534-9.912-1.338l-.03-5.892"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".234"
        stroke-linejoin="round" />
      <path
        d="M154.836 132.918c2.706.192 4.554.918 4.764 2.046.168.9-.75 1.902-2.382 2.808-.732-.084-1.554-.18-2.4-.18l.018-4.674M145.05 136.572c-1.692-.258-2.958-.678-3.594-1.194l-.054-.102c-.306-.618 1.182-1.932 3.66-3.402l-.012 4.698"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M160.89 123.702c.258.768-2.376 2.316-6.102 3.684-1.704.606-3.114 1.242-4.854 2.01-5.178 2.292-9.006 4.92-8.532 5.874l.054.102c-.276-.228-.702-4.944-.702-4.944-.474-.876 3.03-3.468 7.788-5.748 1.53-.732 4.752-1.92 6.27-2.454 2.724-.942 5.424-2.724 5.178-3.384l.9 4.854"
        fill="#ad1519" />
      <path
        d="M160.89 123.702c.258.768-2.376 2.316-6.102 3.684-1.704.606-3.114 1.242-4.854 2.01-5.178 2.292-9.006 4.92-8.532 5.874l.054.102c-.276-.228-.702-4.944-.702-4.944-.474-.876 3.03-3.468 7.788-5.748 1.53-.732 4.752-1.92 6.27-2.454 2.724-.942 5.424-2.724 5.178-3.384l.9 4.854z"
        fill="none"
        stroke="#000"
        stroke-width=".234"
        stroke-linejoin="round" />
      <path
        d="M141.18 141.012c.372 1.398.846 2.748 1.314 4.122a1.87 1.87 0 00-.318-.066c-.102-.018-.216-.024-.324-.03-.222-.984-.528-1.974-.852-2.964-.576.864-1.2 1.704-1.698 2.58-.204-.042-.408-.09-.612-.12-.204-.03-.414-.042-.624-.066a82.245 82.245 0 002.52-3.546c.096.024.192.06.3.072.096.012.198.012.294.018M144.888 145.104c-.174-.006-.354-.024-.528-.018-.18 0-.36.024-.534.036l-.072-3.846 2.694-.048a1.16 1.16 0 00-.036.246c0 .078.024.162.042.24-.486-.03-1.008-.06-1.626-.048l.06 3.438M149.112 144.474c.432-.036.846-.114 1.26-.186-.006.078-.018.162-.012.246.006.078.036.156.06.234l-3.642.3c.006-.084.018-.162.012-.24-.006-.084-.036-.162-.06-.24.372.012.822.012 1.326-.03l-.318-3.462c.174 0 .354 0 .528-.018.18-.012.354-.042.528-.066l.318 3.462M152.49 143.934c.426-.096.954-.162.954-.642a1.553 1.553 0 00-.036-.288c-.138-.564-.564-.756-1.278-.546l.36 1.476m-1.884-3.252c.174-.03.354-.054.528-.09.168-.036.342-.09.51-.138l.432 1.764.048-.006c.096-.246.228-.54.294-.714l.54-1.332c.216-.036.426-.066.63-.108.216-.048.42-.108.624-.168l-.186.402c-.288.6-.594 1.206-.846 1.812.672-.024 1.188.216 1.32.756.09.372-.06.666-.408.918-.264.186-.768.282-1.098.36l-1.464.318-.924-3.774M156.456 140.52l1.278.821-.15-1.439-1.128.618m1.086-.996c-.03-.414-.108-.822-.186-1.26.18-.084.366-.162.54-.264.18-.096.342-.204.516-.312l.36 4.338a4.502 4.502 0 00-.246.114c-.078.042-.15.09-.222.144l-3.828-2.43c.102-.048.21-.096.306-.15.102-.054.186-.114.282-.168.324.27.66.492 1.044.78l1.434-.786z"
        fill="#c8b100" />
      <path
        d="M90.12 179.73c0 .684.582 1.236 1.302 1.236.714 0 1.295-.552 1.295-1.236 0-.678-.58-1.23-1.295-1.23-.72 0-1.302.552-1.302 1.23z"
        fill="none"
        stroke="#000"
        stroke-width=".03" />
      <path
        d="M104.79 190.368c3.984 0 7.536-.594 9.846-1.506 1.32-.6 3.096-1.038 5.04-1.302a20.226 20.226 0 014.11-.144c1.638.036 4.002-.444 6.372-1.488 1.956-.87 3.594-1.926 4.68-2.946l-.942-.84-.27-2.376-2.58-2.952-1.29-1.098-3.054-2.442-1.56-.126-.474-1.35-19.746 2.316-19.812-2.316-.474 1.35-1.566.126-3.048 2.442-1.29 1.098-2.58 2.952-.264 2.376-.948.84c1.092 1.02 2.724 2.076 4.68 2.946 2.37 1.044 4.734 1.524 6.372 1.488a20.226 20.226 0 014.11.144c1.944.264 3.72.702 5.04 1.302 2.316.912 5.664 1.506 9.648 1.506"
        fill="#ad1519" />
      <path
        d="M104.79 190.368c3.984 0 7.536-.594 9.846-1.506 1.32-.6 3.096-1.038 5.04-1.302a20.226 20.226 0 014.11-.144c1.638.036 4.002-.444 6.372-1.488 1.956-.87 3.594-1.926 4.68-2.946l-.942-.84-.27-2.376-2.58-2.952-1.29-1.098-3.054-2.442-1.56-.126-.474-1.35-19.746 2.316-19.812-2.316-.474 1.35-1.566.126-3.048 2.442-1.29 1.098-2.58 2.952-.264 2.376-.948.84c1.092 1.02 2.724 2.076 4.68 2.946 2.37 1.044 4.734 1.524 6.372 1.488a20.226 20.226 0 014.11.144c1.944.264 3.72.702 5.04 1.302 2.316.912 5.664 1.506 9.648 1.506z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M105.09 164.292c-7.356.012-13.95.882-18.654 2.298a.723.723 0 00-.504.75c-.006.312.174.6.504.702 4.704 1.416 11.298 2.286 18.654 2.298 7.362-.012 13.95-.882 18.654-2.298a.698.698 0 00.498-.702c.018-.33-.162-.642-.498-.75-4.704-1.416-11.292-2.286-18.654-2.298"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M105.072 165.258c-6.636.006-12.642.774-17.208 1.956 4.566 1.182 10.572 1.902 17.208 1.914 6.642-.012 12.678-.732 17.244-1.914-4.566-1.182-10.602-1.95-17.244-1.956"
        fill="#ad1519" />
      <path d="M105.57 165.216v3.942" fill="none" stroke="#000" stroke-width=".054" />
      <path d="M104.496 165.216v3.942" fill="none" stroke="#000" stroke-width=".084" />
      <path d="M103.488 165.216v3.942" fill="none" stroke="#000" stroke-width=".108" />
      <path d="M102.486 165.216v3.942" fill="none" stroke="#000" stroke-width=".138" />
      <path d="M101.592 165.216v3.942" fill="none" stroke="#000" stroke-width=".168" />
      <path
        d="M100.698 165.384v3.75m-.81-3.702l-.024 3.582"
        fill="none"
        stroke="#000"
        stroke-width=".198" />
      <path
        d="M99.114 165.498l-.024 3.516m-.774-3.42v3.3"
        fill="none"
        stroke="#000"
        stroke-width=".222" />
      <path
        d="M97.614 165.636v3.168m-.714-3.072v3.048m-.69-3v2.904"
        fill="none"
        stroke="#000"
        stroke-width=".252" />
      <path d="M95.472 165.804v2.808" fill="none" stroke="#000" stroke-width=".276" />
      <path d="M94.782 165.948v2.616" fill="none" stroke="#000" stroke-width=".306" />
      <path d="M94.044 166.014v2.436" fill="none" stroke="#000" stroke-width=".336" />
      <path
        d="M93.306 166.134v2.172m-.774-2.076l-.024 1.932"
        fill="none"
        stroke="#000"
        stroke-width=".36" />
      <path d="M91.758 166.392v1.705" fill="none" stroke="#000" stroke-width=".378" />
      <path d="M91.044 166.53v1.416" fill="none" stroke="#000" stroke-width=".408" />
      <path d="M90.27 166.722v1.11" fill="none" stroke="#000" stroke-width=".438" />
      <path d="M89.472 166.812v.828" fill="none" stroke="#000" stroke-width=".462" />
      <path d="M88.632 167.004v.402" fill="none" stroke="#000" stroke-width=".546" />
      <path
        d="M106.692 165.264v3.894m1.32-3.846l.024 3.822m1.788-3.702v3.606"
        fill="none"
        stroke="#000"
        stroke-width=".03" />
      <path
        d="M105.042 170.346c-7.445-.018-14.13-.948-18.834-2.4.39.186.354.671-.132 1.92-.588 1.518-1.5 1.451-1.5 1.451 5.196 1.537 12.438 2.497 20.496 2.51 8.064-.013 15.36-.973 20.562-2.51 0 0-.918.067-1.506-1.45-.486-1.25-.522-1.735-.126-1.92-4.704 1.451-11.514 2.381-18.96 2.4"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M105.072 173.82c-8.058-.012-15.3-.972-20.496-2.508-.348-.102-.714.03-.828.36a.635.635 0 00.42.81c5.226 1.602 12.648 2.61 20.904 2.628 8.262-.019 15.714-1.026 20.94-2.628a.635.635 0 00.42-.81c-.114-.33-.48-.462-.828-.36-5.202 1.536-12.468 2.496-20.532 2.508"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M105.072 165.258c-6.636.006-12.642.774-17.208 1.956 4.566 1.182 10.572 1.902 17.208 1.914 6.642-.012 12.678-.732 17.244-1.914-4.566-1.182-10.602-1.95-17.244-1.956z"
        fill="none"
        stroke="#000"
        stroke-width=".234"
        stroke-linejoin="round" />
      <path
        d="M99.324 171.99c0 .348.294.624.66.624.36 0 .66-.276.66-.624 0-.342-.3-.624-.66-.624-.366 0-.66.282-.66.624"
        fill="#fff"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M105.09 171.504h-1.974c-.36 0-.666.276-.666.618 0 .348.294.624.66.624h3.984c.366 0 .66-.276.66-.624 0-.342-.306-.618-.666-.618h-1.998"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M95.184 170.958l-1.416-.162c-.366-.042-.702.198-.744.54-.048.342.21.654.576.69l1.422.168 1.452.168c.36.042.69-.198.732-.54.042-.342-.216-.654-.576-.696l-1.446-.168"
        fill="#058e6e"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M89.418 170.832c0 .348.294.624.66.624.367 0 .66-.276.66-.624 0-.342-.293-.624-.66-.624-.366 0-.66.282-.66.624"
        fill="#fff"
        stroke="#000"
        stroke-width=".234" />
      <path d="M85.032 169.704l.732.954 2.022-.258-1.614-1.176z" fill="#ad1519" />
      <path
        d="M85.032 169.704l.732.954 2.022-.258-1.614-1.176-1.14.48"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M114.996 170.958l1.416-.162c.36-.042.702.198.744.54a.628.628 0 01-.576.69l-1.422.168-1.452.168c-.366.042-.69-.198-.732-.54-.048-.342.216-.654.576-.696l1.446-.168"
        fill="#058e6e"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M109.536 171.99c0 .348.3.624.66.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.36 0-.66.282-.66.624M119.442 170.832c0 .348.294.624.66.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.366 0-.66.282-.66.624"
        fill="#fff"
        stroke="#000"
        stroke-width=".234" />
      <path d="M125.142 169.704l-.726.954-2.021-.258 1.613-1.176z" fill="#ad1519" />
      <path
        d="M125.142 169.704l-.726.954-2.021-.258 1.613-1.176 1.134.48M87.072 167.004c4.65 1.308 10.974 2.112 18 2.124 7.032-.012 13.386-.816 18.036-2.124"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M90.204 185.148l.828-.666 1.248 2.04c-1.35.828-2.28 2.268-2.28 3.906 0 .186.012.366.036.546.126 2.604 3.3 4.752 7.32 4.752 2.088 0 3.978-.57 5.304-1.488.036.402.072.75.126 1.116-1.458.852-3.36 1.368-5.43 1.368-4.626 0-8.244-2.634-8.418-5.742a5.671 5.671 0 01-.03-.552c0-1.656.756-3.156 1.956-4.194l-.66-1.086"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M90.258 185.124c-1.578 1.182-2.562 2.784-2.562 4.548 0 2.028 1.332 3.84 3.348 5.046-1.242-1.002-1.998-2.298-2.106-3.738a5.671 5.671 0 01-.03-.552c0-1.656.756-3.156 1.956-4.194l-.606-1.11"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M76.326 183.066c-.888.99-1.428 2.274-1.428 3.672 0 .846.198 1.65.546 2.37 1.278 2.628 5.292 4.542 10.056 4.542 1.296 0 2.538-.138 3.684-.402-.252-.276-.45-.582-.648-.888-.954.186-1.974.288-3.036.288-4.362 0-8.016-1.698-9.072-3.99a4.399 4.399 0 01-.438-1.92c0-1.392.654-2.64 1.674-3.492l-1.578-2.58-.846.672 1.086 1.728"
        fill="#c8b100" />
      <path
        d="M76.326 183.066c-.888.99-1.428 2.274-1.428 3.672 0 .846.198 1.65.546 2.37 1.278 2.628 5.292 4.542 10.056 4.542 1.296 0 2.538-.138 3.684-.402-.252-.276-.45-.582-.648-.888-.954.186-1.974.288-3.036.288-4.362 0-8.016-1.698-9.072-3.99a4.399 4.399 0 01-.438-1.92c0-1.392.654-2.64 1.674-3.492l-1.578-2.58-.846.672z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M77.94 191.712c-1.146-.726-2.016-1.614-2.496-2.604a5.434 5.434 0 01-.546-2.37c0-1.398.54-2.682 1.428-3.672l-.96-1.554c-.918 1.176-1.452 2.556-1.452 4.02 0 2.52 1.602 4.722 4.026 6.18"
        fill="#c8b100" />
      <path
        d="M77.94 191.712c-1.146-.726-2.016-1.614-2.496-2.604a5.434 5.434 0 01-.546-2.37c0-1.398.54-2.682 1.428-3.672l-.96-1.554c-.918 1.176-1.452 2.556-1.452 4.02 0 2.52 1.602 4.722 4.026 6.18z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M105.024 197.238c1.056 0 1.968-.696 2.184-1.638.138-.828.228-1.77.246-2.772.006-.108-.006-.21-.006-.312 0-.12.024-.246.03-.366.036-2.112.336-3.972.762-5.112l-3.216-3.084-3.258 3.084c.432 1.14.732 3 .774 5.112 0 .12.024.246.024.366 0 .102-.006.204-.006.312.018 1.002.108 1.944.246 2.772.216.942 1.164 1.638 2.22 1.638"
        fill="#c8b100" />
      <path
        d="M105.024 197.238c1.056 0 1.968-.696 2.184-1.638.138-.828.228-1.77.246-2.772.006-.108-.006-.21-.006-.312 0-.12.024-.246.03-.366.036-2.112.336-3.972.762-5.112l-3.216-3.084-3.258 3.084c.432 1.14.732 3 .774 5.112 0 .12.024.246.024.366 0 .102-.006.204-.006.312.018 1.002.108 1.944.246 2.772.216.942 1.164 1.638 2.22 1.638z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M105.024 196.236c.546 0 1.008-.348 1.122-.834.138-.786.222-1.68.24-2.628 0-.096-.006-.192-.006-.288 0-.12.018-.234.024-.354.03-1.992.318-3.75.726-4.83l-2.124-2.01-2.124 2.01c.402 1.08.69 2.838.726 4.83 0 .12.024.234.024.354 0 .096-.006.192-.006.288.018.948.102 1.842.24 2.628.108.486.612.834 1.158.834"
        fill="#c8b100" />
      <path
        d="M105.024 196.236c.546 0 1.008-.348 1.122-.834.138-.786.222-1.68.24-2.628 0-.096-.006-.192-.006-.288 0-.12.018-.234.024-.354.03-1.992.318-3.75.726-4.83l-2.124-2.01-2.124 2.01c.402 1.08.69 2.838.726 4.83 0 .12.024.234.024.354 0 .096-.006.192-.006.288.018.948.102 1.842.24 2.628.108.486.612.834 1.158.834z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M119.82 185.148l-.834-.666-1.248 2.04c1.356.828 2.286 2.268 2.286 3.906 0 .186-.012.366-.036.546-.126 2.604-3.3 4.752-7.32 4.752-2.094 0-3.978-.57-5.304-1.488-.036.402-.073.75-.132 1.116 1.464.852 3.36 1.368 5.435 1.368 4.626 0 8.245-2.634 8.42-5.742.017-.186.03-.366.03-.552 0-1.656-.763-3.156-1.963-4.194l.666-1.086"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M119.766 185.124c1.578 1.182 2.562 2.784 2.562 4.548 0 2.028-1.332 3.84-3.348 5.046 1.242-1.002 1.998-2.298 2.106-3.738.018-.186.03-.366.03-.552 0-1.656-.762-3.156-1.962-4.194l.612-1.11"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M133.697 183.066c.882.99 1.43 2.274 1.43 3.672 0 .846-.2 1.65-.548 2.37-1.283 2.628-5.292 4.542-10.055 4.542-1.297 0-2.539-.138-3.69-.402.257-.276.455-.582.653-.888.948.186 1.974.288 3.037.288 4.361 0 8.01-1.698 9.065-3.99a4.399 4.399 0 00.438-1.92c0-1.392-.653-2.64-1.674-3.492l1.578-2.58.852.672-1.086 1.728"
        fill="#c8b100" />
      <path
        d="M133.697 183.066c.882.99 1.43 2.274 1.43 3.672 0 .846-.2 1.65-.548 2.37-1.283 2.628-5.292 4.542-10.055 4.542-1.297 0-2.539-.138-3.69-.402.257-.276.455-.582.653-.888.948.186 1.974.288 3.037.288 4.361 0 8.01-1.698 9.065-3.99a4.399 4.399 0 00.438-1.92c0-1.392-.653-2.64-1.674-3.492l1.578-2.58.852.672z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M132.084 191.712c1.146-.726 2.016-1.614 2.496-2.604.348-.72.546-1.524.546-2.37 0-1.398-.546-2.682-1.428-3.672l.96-1.554c.918 1.176 1.446 2.556 1.446 4.02 0 2.52-1.602 4.722-4.02 6.18"
        fill="#c8b100" />
      <path
        d="M132.084 191.712c1.146-.726 2.016-1.614 2.496-2.604.348-.72.546-1.524.546-2.37 0-1.398-.546-2.682-1.428-3.672l.96-1.554c.918 1.176 1.446 2.556 1.446 4.02 0 2.52-1.602 4.722-4.02 6.18z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M103.878 186.642c0 .594.51 1.074 1.146 1.074.63 0 1.14-.48 1.14-1.074 0-.6-.51-1.086-1.14-1.086-.636 0-1.146.486-1.146 1.086"
        fill="#fff" />
      <path
        d="M103.878 186.642c0 .594.51 1.074 1.146 1.074.63 0 1.14-.48 1.14-1.074 0-.6-.51-1.086-1.14-1.086-.636 0-1.146.486-1.146 1.086z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M103.878 188.76c0 .594.51 1.08 1.146 1.08.63 0 1.14-.486 1.14-1.08 0-.6-.51-1.08-1.14-1.08-.636 0-1.146.48-1.146 1.08M104.106 191.04c0 .48.414.864.918.864.498 0 .906-.384.906-.864s-.408-.864-.906-.864c-.504 0-.918.384-.918.864M104.364 193.098c0 .342.294.618.66.618.36 0 .654-.276.654-.618a.643.643 0 00-.654-.63c-.366 0-.66.282-.66.63M104.496 194.892c0 .276.234.498.528.498a.51.51 0 00.522-.498.51.51 0 00-.522-.498c-.294 0-.528.222-.528.498"
        fill="#fff"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M105.12 180.132l.738-.132c-.115-.3-.144-.63-.144-.978 0-1.542 1.326-2.79 2.952-2.79 1.308 0 2.424.81 2.801 1.926.05-.03.283 1.008.41.996.101-.012.09-1.08.131-1.062.185-1.404 1.476-2.358 2.922-2.358 1.626 0 2.946 1.248 2.946 2.79 0 .114-.006.228-.024.342l.924.912.498-1.164c-.198-.366-.276-.78-.276-1.218 0-1.476 1.26-2.664 2.814-2.664a2.85 2.85 0 012.34 1.182l.594.75-.006-.918c0-.93.396-1.758 1.296-1.908 0 0 1.038-.06 2.418 1.02 1.374 1.08 2.13 1.974 2.13 1.974l.12-1.08s-1.14-1.77-2.382-2.49c-.684-.396-1.716-.81-2.538-.678-.865.144-1.488.84-1.806 1.644a4.18 4.18 0 00-2.13-.582c-1.686 0-3.198.924-3.792 2.316-.774-.84-1.854-1.35-3.12-1.35-1.345 0-2.574.606-3.343 1.536a4.314 4.314 0 00-2.927-1.122c-1.488 0-2.814.732-3.564 1.83-.75-1.098-2.076-1.83-3.564-1.83a4.304 4.304 0 00-2.922 1.122c-.768-.93-2.004-1.536-3.349-1.536-1.265 0-2.339.51-3.113 1.35-.6-1.392-2.113-2.316-3.792-2.316-.786 0-1.512.216-2.13.582-.324-.804-.942-1.5-1.813-1.644-.815-.132-1.847.282-2.53.678-1.249.72-2.389 2.49-2.389 2.49l.12 1.08s.762-.894 2.136-1.974c1.374-1.086 2.411-1.02 2.411-1.02.907.15 1.297.978 1.297 1.908l-.006.918.594-.75c.504-.714 1.367-1.182 2.34-1.182 1.553 0 2.814 1.188 2.814 2.664 0 .438-.078.852-.276 1.218l.498 1.164.924-.912c-.012-.114-.024-.228-.024-.342 0-1.542 1.32-2.79 2.946-2.79 1.452 0 2.736.954 2.928 2.358.036-.018.03 1.05.132 1.062.12.012.36-1.026.402-.996.383-1.116 1.494-1.926 2.807-1.926 1.626 0 2.947 1.248 2.947 2.79 0 .348-.018.678-.145.978l.774.132"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M125.376 176.454c.168.498.018.99-.342 1.098-.36.114-.792-.198-.966-.696-.168-.498-.018-.99.342-1.104.36-.108.792.204.966.702M112.548 178.938c.066.522-.18.978-.558 1.02-.378.042-.738-.342-.804-.864-.066-.516.186-.978.558-1.02.378-.042.738.342.804.864M97.656 178.938c-.066.522.186.978.558 1.02.378.042.738-.342.804-.864.066-.516-.18-.978-.558-1.02-.372-.042-.732.342-.804.864M84.834 176.454c-.168.498-.018.99.342 1.098.36.114.792-.198.96-.696.168-.498.018-.99-.342-1.104-.36-.108-.786.204-.96.702"
        fill="#fff"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M90.408 185.01c.636-.402 1.188-1.074 1.38-1.818 0 0 .078.15.426.354.354.198.654.192.654.192s-.102-.582-.15-.792c-.054-.204-.054-.828-.192-1.392-.138-.558-.378-1.008-.378-1.008a1.19 1.19 0 01-.948.246 1.122 1.122 0 01-.792-.54s-.396.348-.726.828c-.33.486-.558 1.068-.678 1.248-.126.18-.432.69-.432.69s.282.108.684.03c.402-.072.528-.192.528-.192a3.045 3.045 0 00.624 2.154"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M90.672 178.884a1.103 1.103 0 00-.402.648c-.048.264.006.522.138.738 0 0-.528.264-1.098.414-.432.114-1.194.12-1.422.12-.228.012-.69.018-.69.018s.042-.102.168-.33c.162-.276.3-.45.3-.45-.762-.174-1.41-.672-1.818-1.254.594-.408 1.38-.66 2.16-.582 0 0-.072-.204-.12-.516-.036-.258-.036-.366-.036-.366l.642.234c.21.078.924.33 1.29.576.48.324.888.75.888.75M92.382 179.172a1.036 1.036 0 01-.252 1.38s.402.426.882.756c.36.246 1.08.492 1.29.57.216.078.642.24.642.24s0-.108-.036-.366c-.048-.312-.12-.522-.12-.522.78.084 1.572-.174 2.166-.588-.414-.582-1.062-1.074-1.824-1.248 0 0 .138-.168.3-.444.126-.234.168-.336.168-.336l-.69.018c-.228 0-.99.006-1.422.12-.57.15-1.104.414-1.104.414"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M90.12 179.73c0 .684.582 1.236 1.302 1.236.714 0 1.295-.552 1.295-1.236 0-.678-.58-1.23-1.295-1.23-.72 0-1.302.552-1.302 1.23"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M105.066 186.984c.63-.57 1.11-1.416 1.17-2.292 0 0 .114.162.546.318.438.156.768.096.768.096s-.234-.63-.33-.852c-.102-.222-.234-.918-.504-1.518-.264-.6-.63-1.056-.63-1.056a1.344 1.344 0 01-2.004 0s-.366.456-.63 1.056c-.27.6-.402 1.296-.504 1.518-.102.222-.336.852-.336.852s.336.06.768-.096.552-.318.552-.318c.06.876.516 1.722 1.134 2.292"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M104.1 180.102a1.202 1.202 0 00-.318.798c0 .3.114.582.306.792 0 0-.534.402-1.134.672-.462.21-1.308.354-1.56.402l-.768.144s.024-.12.12-.402c.12-.336.24-.558.24-.558-.882-.048-1.71-.486-2.286-1.056.576-.564 1.404-.996 2.286-1.05 0 0-.12-.216-.24-.558a3.277 3.277 0 01-.12-.402l.768.144c.252.048 1.098.192 1.56.402.6.276 1.146.666 1.146.666M106.056 180.102a1.173 1.173 0 01.012 1.59s.534.402 1.14.672c.456.21 1.302.354 1.56.402l.756.144s-.012-.12-.114-.402c-.12-.336-.24-.558-.24-.558.882-.048 1.716-.486 2.286-1.056-.57-.564-1.398-.996-2.286-1.05 0 0 .12-.216.24-.558.096-.276.114-.402.114-.402l-.756.144c-.258.048-1.104.192-1.56.402-.606.276-1.152.666-1.152.666M119.802 185.01c-.636-.402-1.188-1.074-1.386-1.818 0 0-.072.15-.426.354-.348.198-.654.192-.654.192s.102-.582.156-.792c.054-.204.054-.828.186-1.392.138-.558.384-1.008.384-1.008.252.204.594.306.942.246.354-.06.636-.264.798-.54 0 0 .396.348.726.828.324.486.552 1.068.672 1.248.126.18.432.69.432.69s-.282.108-.684.03c-.402-.072-.528-.192-.528-.192.09.768-.168 1.572-.618 2.154"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M119.532 178.884c.204.162.36.384.402.648.054.264 0 .522-.132.738 0 0 .528.264 1.098.414.432.114 1.194.12 1.416.12.234.012.69.018.69.018s-.036-.102-.168-.33a3.814 3.814 0 00-.294-.45c.756-.174 1.404-.672 1.818-1.254-.594-.408-1.386-.66-2.16-.582 0 0 .066-.204.114-.516.036-.258.036-.366.036-.366l-.636.234c-.216.078-.93.33-1.296.576-.474.324-.888.75-.888.75M117.828 179.172c-.132.21-.192.474-.15.738.054.264.198.486.402.642 0 0-.402.426-.882.756-.366.246-1.08.492-1.296.57-.21.078-.636.24-.636.24s-.006-.108.036-.366c.048-.312.114-.522.114-.522-.774.084-1.566-.174-2.16-.588.408-.582 1.062-1.074 1.818-1.248 0 0-.138-.168-.294-.444a2.504 2.504 0 01-.168-.336l.684.018c.228 0 .996.006 1.422.12.57.15 1.104.414 1.104.414"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M117.486 179.73c0 .684.582 1.236 1.302 1.236.72 0 1.302-.552 1.302-1.236 0-.678-.582-1.23-1.302-1.23-.72 0-1.302.552-1.302 1.23M132.03 176.994c-.306.324-.942.258-1.416-.15-.474-.402-.612-.996-.306-1.314.306-.324.942-.252 1.416.15.474.408.612.996.306 1.314"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M130.182 176.208c.066.222.216.45.432.636.474.408 1.11.474 1.416.15a.632.632 0 00.108-.15s.66 1.248 1.44 1.668c.78.42 2.1.312 2.1.312 0 .96-.786 1.734-1.8 1.734-.594 0-1.152-.246-1.482-.666l-.138.642s-.816-.162-1.188-1.092.03-2.28.03-2.28-.198.576-.504.966c-.306.384-1.086.804-1.494.996-.408.186-.822.474-.822.474s-.018-.108-.036-.366c-.012-.306.012-.498.012-.498-.75.102-1.62-.024-2.298-.288.288-.57.84-1.104 1.566-1.38 0 0-.258-.216-.498-.45-.198-.204-.258-.294-.258-.294s.51-.078.762-.114c.258-.03 1.104-.168 1.608-.132.378.024.792.084 1.044.132M80.022 176.208c-.066.222-.21.45-.432.636-.474.408-1.104.474-1.416.15a.604.604 0 01-.102-.15s-.666 1.248-1.446 1.668c-.774.42-2.094.312-2.094.312 0 .96.78 1.734 1.794 1.734.594 0 1.152-.246 1.488-.666l.138.642s.816-.162 1.188-1.092-.036-2.28-.036-2.28.204.576.51.966c.306.384 1.086.804 1.494.996.402.186.822.474.822.474s.018-.108.03-.366c.018-.306-.006-.498-.006-.498.744.102 1.614-.024 2.298-.288a2.972 2.972 0 00-1.572-1.38s.264-.216.498-.45c.204-.204.264-.294.264-.294s-.51-.078-.762-.114c-.258-.03-1.104-.168-1.614-.132a9.44 9.44 0 00-1.044.132"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M78.174 176.994c.312.324.942.258 1.416-.15.48-.402.612-.996.306-1.314-.306-.324-.942-.252-1.416.15-.474.408-.612.996-.306 1.314M103.782 180.9c0 .678.582 1.23 1.302 1.23.714 0 1.302-.552 1.302-1.23 0-.684-.582-1.236-1.302-1.236-.72 0-1.302.552-1.302 1.236"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M102.372 199.62c0 1.392 1.194 2.52 2.658 2.52 1.47 0 2.658-1.128 2.658-2.52 0-1.392-1.188-2.514-2.658-2.514-1.464 0-2.658 1.122-2.658 2.514"
        fill="#005bbf"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M104.334 206.676v-1.356h-1.452v-1.38h1.452v-3.966h-1.83c-.018-.126-.132-.222-.132-.354 0-.348.072-.684.21-.984 0-.012.012-.012.018-.018h4.872c0 .006.012.006.018.018.132.3.21.636.21.984 0 .132-.114.228-.132.354h-1.776V203.94h1.452v1.38h-1.452v1.356z"
        fill="#c8b100" />
      <path
        d="M104.334 206.676v-1.356h-1.452v-1.38h1.452v-3.966h-1.83c-.018-.126-.132-.222-.132-.354 0-.348.072-.684.21-.984 0-.012.012-.012.018-.018h4.872c0 .006.012.006.018.018.132.3.21.636.21.984 0 .132-.114.228-.132.354h-1.776V203.94h1.452v1.38h-1.452v1.356z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M105.294 93.402c-7.847 0-15.63 1.92-22.17 5.124-4.818 2.388-8.016 7.2-8.016 12.714v19.98h60.252v-19.98c0-5.514-3.192-10.326-8.015-12.714-6.541-3.204-14.197-5.124-22.05-5.124"
        fill="#ccc" />
      <path
        d="M105.294 93.402c-7.847 0-15.63 1.92-22.17 5.124-4.818 2.388-8.016 7.2-8.016 12.714v19.98h60.252v-19.98c0-5.514-3.192-10.326-8.015-12.714-6.541-3.204-14.197-5.124-22.05-5.124z"
        fill="none"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M105.168 131.25h30.192v33.432h-30.192z"
        fill="#ccc"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M105.192 111.258c0-7.896-6.695-14.292-15.03-14.292-8.334 0-15.09 6.396-15.09 14.292v20.01h30.12v-20.01"
        fill="#ad1519" />
      <path
        d="M81.648 99.462c.942-.498 2.232-1.332 3.618-1.662l-.09 34.176h-3.528z"
        fill="#c8b100" />
      <path
        d="M81.648 99.462c.942-.498 2.232-1.332 3.618-1.662l-.09 34.176h-3.528z"
        fill="none"
        stroke="#000"
        stroke-width=".312" />
      <path d="M75.018 111.528c.09-4.212 1.77-7.35 3.438-9.402v29.682H75.06z" fill="#c8b100" />
      <path
        d="M75.018 111.528c.09-4.212 1.77-7.35 3.438-9.402v29.682H75.06z"
        fill="none"
        stroke="#000"
        stroke-width=".3"
        stroke-linejoin="round" />
      <path d="M88.368 97.05a16.404 16.404 0 013.522 0v34.926h-3.522z" fill="#c7b500" />
      <path
        d="M88.368 97.05a16.404 16.404 0 013.522 0v34.926h-3.522z"
        fill="none"
        stroke="#000"
        stroke-width=".312" />
      <path d="M94.992 97.8c1.38.276 2.94 1.134 3.618 1.578v32.598h-3.528z" fill="#c8b100" />
      <path
        d="M94.992 97.8c1.38.276 2.94 1.134 3.618 1.578v32.598h-3.528z"
        fill="none"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M75.072 131.25h30.108v33.432H75.072z"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M101.886 102.456c1.47 1.308 2.85 4.272 3.354 7.656l.084 21.864h-3.522z"
        fill="#c8b100" />
      <path
        d="M101.886 102.456c1.47 1.308 2.85 4.272 3.354 7.656l.084 21.864h-3.522z"
        fill="none"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M105.192 111.258c0-7.896-6.695-14.292-15.03-14.292-8.334 0-15.09 6.396-15.09 14.292v20.01h30.12v-20.01"
        fill="none"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M135.39 131.268v-20.01c0-7.896-6.768-14.292-15.102-14.292-8.34 0-15.096 6.396-15.096 14.292v20.01h30.198"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M119.664 106.548l-1.056.294v2.676l1.056.288v-3.258m1.02 0l1.056.294v2.676l-1.056.288v-3.258m-1.188-4.848c0 .372.312.672.702.672.384 0 .702-.3.702-.672 0-.366-.318-.66-.702-.66-.39 0-.702.294-.702.66m7.266 13.65l-.312-1.002h-2.826l-.306 1.002h3.444m-13.212 0l.306-1.002h2.832l.3 1.002h-3.438m12.564-5.406l.606.87-1.836 2.04-1.002-.432 2.232-2.478m-.774-.63l-1.008-.426-1.836 2.04.606.864 2.238-2.478m1.368-5.886c-.9-.678-1.92-1.218-3.024-1.596l.786-.732c.882.324 1.71.756 2.472 1.266l-.234 1.062m-.51.876a9.888 9.888 0 00-3.024-1.608l-.234 1.02a8.517 8.517 0 012.502 1.254l.756-.666m3.468 8.55l-1.05-.246s-.06-1.722-.036-1.332c.03.443-.114-1.344-.114-1.344l1.062-.348c.102.54.138 1.104.138 1.674v1.596m.87-3.312l1.056.234.15 2.67-1.044.348-.006-1.536c0-.594-.048-1.152-.156-1.716m-1.29-2.814a.726.726 0 01-.99.078.641.641 0 01-.078-.937.727.727 0 01.99-.077c.294.24.33.66.078.936m-3.804-2.976l.498-.864a10.43 10.43 0 012.28 1.931 1.688 1.688 0 011.554.3c.69.56.768 1.537.186 2.185l-.09.096c.42.936.702 1.944.792 3l-1.02-.006a8.396 8.396 0 00-.66-2.562 1.904 1.904 0 01-.876-.096l-2.562 2.838-.774-.624 2.55-2.838a1.47 1.47 0 01.06-1.71 9.314 9.314 0 00-1.938-1.65m-11.304 6.192l-.6.87 1.836 2.04 1.002-.432-2.238-2.478m.78-.63l1.002-.426 1.836 2.04-.6.864-2.238-2.478m-1.374-5.886a10.96 10.96 0 013.024-1.596l-.78-.732c-.882.324-1.716.756-2.472 1.266l.228 1.062m.51.876a9.957 9.957 0 013.024-1.608l.234 1.02a8.59 8.59 0 00-2.502 1.254l-.756-.666m-3.462 8.55l1.05-.246s.054-1.722.03-1.332c-.024.443.114-1.344.114-1.344l-1.056-.348a8.561 8.561 0 00-.144 1.674zm-.876-3.312l-1.056.234-.15 2.67 1.05.348v-1.536c0-.594.054-1.152.156-1.716m1.296-2.814a.726.726 0 00.99.078.64.64 0 00.078-.936.726.726 0 00-.99-.078.64.64 0 00-.078.936m3.804-2.976l-.504-.864a10.516 10.516 0 00-2.274 1.932 1.694 1.694 0 00-1.56.3c-.69.558-.774 1.536-.18 2.184l.084.096a9.554 9.554 0 00-.792 3l1.026-.006c.084-.9.306-1.758.654-2.562.294.036.6.006.876-.096l2.568 2.838.774-.624-2.55-2.838c.342-.522.33-1.2-.066-1.71a9.348 9.348 0 011.944-1.65m6.894-1.41c.81.126 1.548.348 2.286.66l.504-.858a10.998 10.998 0 00-2.7-.768c-.162-.702-.816-1.224-1.602-1.224-.786 0-1.44.516-1.602 1.212-1.002.138-1.95.396-2.838.78l.504.858a9.657 9.657 0 012.448-.666c.186.396.516.696.948.84l.006 4.2h1.02l.006-4.188a1.64 1.64 0 001.02-.846m4.176 13.824v-.81h2.766a1.588 1.588 0 011.014-.972v-2.424l1.026.006v2.406c.666.198 1.146.786 1.146 1.482 0 .108-.012.21-.036.312h-.978a.72.72 0 00.072-.312c0-.366-.312-.66-.696-.66-.39 0-.702.294-.702.66 0 .108.024.21.072.3l-3.684.012m-1.656 0v-.81l-2.484-.012a1.426 1.426 0 00-.156-.3l2.88-3.276-.774-.63-2.868 3.282c-.054-.018-.078-.036-.132-.054l-.012-5.418h-1.014l-.006 5.442a.398.398 0 00-.114.054l-2.988-3.306-.774.63 2.982 3.312c-.048.084-.09.174-.12.276h-2.568v.81h8.154zm-13.548 0a.727.727 0 00.078-.312c0-.366-.312-.66-.702-.66-.39 0-.702.294-.702.66 0 .108.024.21.072.3l-.978.012a1.774 1.774 0 01-.03-.312c0-.696.48-1.284 1.14-1.482v-2.406l1.026-.006.006 2.424c.474.156.852.516 1.014.972h2.76v.81h-3.684"
        fill="#c8b100" />
      <path
        d="M120.666 124.284l1.05-.294v-2.682l-1.05-.288v3.264m-1.014 0l-1.056-.294v-2.682l1.056-.288v3.264m3.69 3.132l.312 1.002h2.826l.306-1.002h-3.444m0-.972l.312-1.002h2.826l.306 1.002h-3.444m-3.918.486c0 .366.318.666.702.666.39 0 .702-.3.702-.666 0-.366-.312-.666-.702-.666-.384 0-.702.3-.702.666m10.08 0c0 .366.312.666.702.666.384 0 .696-.3.696-.666 0-.366-.312-.666-.696-.666-.39 0-.702.3-.702.666m-2.742-10.638l-.312 1.002h-2.826l-.306-1.002h3.444m-9.798 11.124l-.306 1.002h-2.826l-.306-1.002h3.438m0-.972l-.306-1.002h-2.826l-.306 1.002h3.438m-7.56.486c0 .366.312.666.702.666.384 0 .702-.3.702-.666 0-.366-.318-.666-.702-.666-.39 0-.702.3-.702.666m4.146-10.638l.306 1.002h2.832l.3-1.002h-3.438m12.708 5.658l.612-.87-1.818-2.052-1.008.42 2.214 2.502m-.78.624l-1.008.42-1.818-2.058.612-.864 2.214 2.502m-11.532-.714l-.6-.87 1.836-2.04 1.002.432-2.238 2.478m.78.636l1.002.426 1.836-2.04-.6-.87-2.238 2.484m15.966.528l1.056-.3v-2.676l-1.056-.294v3.27m-1.026 0l-1.05-.3v-2.676l1.05-.294v3.27m-19.068 0l1.05-.3v-2.676l-1.05-.294v3.27m-1.026 0l-1.056-.3v-2.676l1.056-.294v3.27m11.094 2.436l-.006-2.004h-1.02l.006 1.986a1.6 1.6 0 00-1.074 1.008h-2.478v.966h2.478c.216.624.828 1.068 1.554 1.068.732 0 1.35-.444 1.56-1.068h2.532v-.966h-2.538a1.573 1.573 0 00-1.014-.99m10.038-.012l-.012-3.258h-1.014v3.27a1.501 1.501 0 00-.228.09l-3.762-4.242-.78.618 3.834 4.326c-.03.06-.066.126-.084.198h-2.784v.966h2.772c.216.624.828 1.068 1.56 1.068.9 0 1.638-.696 1.638-1.554 0-.696-.474-1.284-1.14-1.482m-19.962.018l3.786-4.242.774.63-3.804 4.224c.072.114.126.234.174.372h2.766v.966h-2.766c-.216.624-.834 1.068-1.566 1.068-.906 0-1.638-.696-1.638-1.554 0-.678.456-1.26 1.104-1.47l-.006-3.27h1.014v3.252c.042.012.12.012.162.024m18.828-9.324a.724.724 0 00.63.354c.27 0 .51-.15.624-.366l.978.012a1.602 1.602 0 01-1.116 1.182l.006 3.3h-1.014l-.006-3.324c-.498-.156-.888-.522-1.038-1.002l-2.748-.006v-.15h3.684m-13.494 0v.15h2.55c.03.084.066.168.114.24l-3.15 3.51.774.624 3.108-3.45c.054.03.108.054.168.072v4.596h1.014v-4.566c.048-.018.114-.03.162-.042l3.036 3.456.78-.618-3.048-3.438a1.48 1.48 0 00.174-.384h2.472v-.15zm-7.626 0c.12.558.558 1.014 1.116 1.182l-.006 3.3h1.02v-3.318c.504-.162.888-.528 1.044-1.008l2.742-.006v-.15h-3.684a.721.721 0 01-.624.354.717.717 0 01-.63-.366l-.978.012"
        fill="#c8b100" />
      <path
        d="M113.544 103.428a10.96 10.96 0 013.024-1.596l-.78-.732c-.882.324-1.716.756-2.472 1.266l.228 1.062m.51.876a9.957 9.957 0 013.024-1.608l.234 1.02a8.59 8.59 0 00-2.502 1.254l-.756-.666m-3.462 8.55l1.05-.246s.054-1.722.03-1.332c-.024.444.114-1.344.114-1.344l-1.056-.348a8.561 8.561 0 00-.144 1.674zm-.876-3.312l-1.056.234-.15 2.67 1.05.348v-1.536c0-.594.054-1.152.156-1.716zm1.296-2.814a.726.726 0 00.99.078.64.64 0 00.078-.936.726.726 0 00-.99-.078.64.64 0 00-.078.936zm-1.452 5.238v2.406c-.66.198-1.146.786-1.146 1.482 0 .69.492 1.29 1.152 1.488l-.006 3.294h1.02v-3.312a1.572 1.572 0 001.044-1.002l2.742-.006v-.96h-2.76a1.602 1.602 0 00-1.014-.972l-.006-2.424-1.026.006m5.256-8.214l-.504-.864a10.516 10.516 0 00-2.274 1.932 1.694 1.694 0 00-1.56.3c-.69.558-.774 1.536-.18 2.184l.084.096a9.554 9.554 0 00-.792 3l1.026-.006c.084-.9.306-1.758.654-2.562.294.036.6.006.876-.096l2.568 2.838.774-.624-2.55-2.838c.342-.522.33-1.2-.066-1.71a9.348 9.348 0 011.944-1.65zm-4.074 21.72l3.786-4.23.774.624-3.804 4.218c.072.114.126.234.174.366h2.766v.966h-2.766c-.216.624-.834 1.068-1.566 1.068-.906 0-1.638-.69-1.638-1.548 0-.678.456-1.26 1.104-1.47l-.006-3.264h1.014v3.246c.042.012.12.012.162.024zm8.029-10.392a1.2 1.2 0 00-.126.276h-2.57v.96h2.55c.03.084.073.162.115.24l-3.15 3.498.774.63 3.108-3.444c.054.024.108.048.168.072v4.584h1.014v-4.56c.048-.012.114-.024.162-.042l3.036 3.45.78-.618-3.048-3.432c.078-.114.132-.24.174-.378h2.472v-.96l-2.483-.012c-.037-.108-.103-.204-.157-.3l2.88-3.282-.773-.624-2.87 3.282c-.053-.018-.077-.042-.137-.054l-.006-5.424h-1.02v5.448a.53.53 0 00-.12.054l-2.988-3.306-.774.624 2.988 3.318m2.94-12.738a9.543 9.543 0 012.287.66l.503-.858a10.998 10.998 0 00-2.7-.768c-.162-.702-.816-1.224-1.602-1.224-.786 0-1.44.516-1.601 1.212-1.003.138-1.95.396-2.84.78l.505.858a9.657 9.657 0 012.448-.666c.187.396.516.696.948.84l.006 4.2h1.02l.006-4.188a1.64 1.64 0 001.02-.846z"
        fill="none"
        stroke="#c8b100"
        stroke-width=".156" />
      <path
        d="M129.666 123.036l-1.05-.3v-2.676l1.05-.288v3.264m-19.068 0l1.05-.3v-2.676l-1.05-.288v3.264m-1.026 0l-1.056-.3v-2.676l1.056-.288v3.264m17.136-19.608c-.9-.678-1.92-1.218-3.024-1.596l.786-.732c.882.324 1.71.756 2.472 1.266l-.234 1.062m-.51.876a9.888 9.888 0 00-3.024-1.608l-.234 1.02a8.517 8.517 0 012.502 1.254l.756-.666m-5.532 21.162l-.006-2.004h-1.02l.006 1.986c-.51.15-.906.522-1.074 1.002h-2.478v.966h2.478c.216.624.828 1.068 1.554 1.068.732 0 1.35-.444 1.56-1.068h2.532v-.966h-2.538a1.578 1.578 0 00-1.014-.984zm10.038-.012l-.012-3.252h-1.014v3.264a1.501 1.501 0 00-.228.09l-3.762-4.236-.78.618 3.834 4.32c-.03.06-.066.126-.084.192h-2.784v.966h2.772c.216.624.828 1.068 1.56 1.068.9 0 1.638-.69 1.638-1.548 0-.696-.474-1.284-1.14-1.482zm-1.038-12.6l-1.05-.246s-.06-1.722-.036-1.332c.03.444-.114-1.344-.114-1.344l1.062-.348c.102.54.138 1.104.138 1.674v1.596m.87-3.312l1.056.234.15 2.67-1.044.348-.006-1.536c0-.594-.048-1.152-.156-1.716zm-1.29-2.814a.726.726 0 01-.99.078.64.64 0 01-.078-.936.726.726 0 01.99-.078c.294.24.33.66.078.936zm1.452 5.238l-.006 2.406c.666.198 1.146.786 1.146 1.482 0 .69-.486 1.29-1.152 1.488l.006 3.294h-1.014l-.006-3.312a1.563 1.563 0 01-1.038-1.002l-2.748-.006v-.96h2.766a1.588 1.588 0 011.014-.972v-2.424l1.026.006zm-5.256-8.214l.498-.864a10.408 10.408 0 012.28 1.932 1.682 1.682 0 011.554.3c.69.558.768 1.536.186 2.184l-.09.096c.42.936.702 1.944.792 3l-1.02-.006a8.396 8.396 0 00-.66-2.562 1.904 1.904 0 01-.876-.096l-2.562 2.838-.774-.624 2.55-2.838a1.47 1.47 0 01.06-1.71 9.314 9.314 0 00-1.938-1.65zm-16.086 12.102c0 .366.312.666.702.666.384 0 .696-.3.696-.666 0-.366-.312-.66-.696-.66-.39 0-.702.294-.702.66zm4.782-5.91l-.6.87 1.836 2.04 1.002-.432-2.238-2.478m.78-.63l1.002-.426 1.836 2.04-.6.864-2.238-2.478"
        fill="none"
        stroke="#c8b100"
        stroke-width=".156" />
      <path
        d="M123.342 127.416l.312 1.002h2.826l.306-1.002h-3.444m0-.966l.312-1.002h2.826l.306 1.002h-3.444m-3.918.486c0 .36.318.66.702.66.39 0 .702-.3.702-.66 0-.372-.312-.666-.702-.666-.384 0-.702.294-.702.666zm10.08 0c0 .36.312.66.702.66.384 0 .696-.3.696-.66 0-.372-.312-.666-.696-.666-.39 0-.702.294-.702.666zm-9.84-20.388l-1.056.294v2.676l1.056.288v-3.258m1.02 0l1.056.294v2.676l-1.056.288v-3.258m-1.187-4.848c0 .372.31.672.7.672.385 0 .703-.3.703-.672 0-.366-.318-.66-.702-.66-.39 0-.701.294-.701.66zm7.265 13.65l-.312-1.002h-2.826l-.306 1.002h3.444m0 .966l-.312 1.002h-2.826l-.306-1.002h3.444m2.736-.462c0 .366.312.666.702.666.384 0 .697-.3.697-.666 0-.366-.313-.66-.697-.66-.39 0-.702.294-.702.66zm-12.534 11.562l-.306 1.002h-2.826l-.306-1.002h3.438m0-.966l-.306-1.002h-2.826l-.306 1.002h3.438m-7.56.486c0 .36.312.66.702.66.384 0 .702-.3.702-.66 0-.372-.318-.666-.702-.666-.39 0-.702.294-.702.666zm4.146-11.586l.306-1.002h2.832l.3 1.002h-3.438m0 .966l.306 1.002h2.832l.3-1.002h-3.438m12.708 5.646l.613-.864-1.82-2.052-1.006.42 2.213 2.496m-.78.624l-1.007.414-1.82-2.052.613-.858 2.214 2.496m-11.531-.708l-.6-.876 1.835-2.034 1.002.432-2.237 2.478m.779.63l1.002.426 1.836-2.04-.6-.87-2.238 2.484m11.388-12.564l.607.87-1.837 2.04-1.002-.432 2.232-2.478m-.774-.63l-1.008-.426-1.835 2.04.605.864 2.238-2.478m5.352 13.722l1.056-.3v-2.676l-1.056-.288v3.264M120.666 124.296l1.05-.3v-2.676l-1.05-.288v3.264m-1.014 0l-1.056-.3v-2.676l1.056-.288v3.264"
        fill="none"
        stroke="#c8b100"
        stroke-width=".156" />
      <path
        d="M118.554 115.836c0 .864.738 1.56 1.644 1.56.906 0 1.638-.696 1.638-1.56 0-.858-.732-1.548-1.638-1.548-.906 0-1.644.69-1.644 1.548"
        fill="#058e6e" />
      <path
        d="M120.558 156.444l.03.372.054.205s-.966-.08-1.476.065c-.51.144-.966.354-1.44.75-.474.408-.66.66-1.002.708-.816.132-1.44-.24-1.44-.24s.612-.222 1.068-.786c.456-.564.954-.846 1.17-.918.354-.108 1.596-.03 1.932-.042a22.57 22.57 0 001.104-.114"
        fill="#db4446" />
      <path
        d="M120.558 156.444l.03.372.054.205s-.966-.08-1.476.065c-.51.144-.966.354-1.44.75-.474.408-.66.66-1.002.708-.816.132-1.44-.24-1.44-.24s.612-.222 1.068-.786c.456-.564.954-.846 1.17-.918.354-.108 1.596-.03 1.932-.042a22.57 22.57 0 001.104-.114z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M125.076 157.8s.006-.432.048-.84c.036-.402-.132-.744-.066-.966.066-.222.096-.396.18-.558.084-.156.126-.564.126-.564s-.228.168-.444.324c-.21.162-.36.264-.36.264l.06-.618c.024-.186.132-.534.306-.744.174-.198.522-.534.63-.798.108-.27.084-.864.084-.864s-.276.45-.522.534c-.234.084-.756.372-.756.372s.474-.474.474-.93c0-.45-.192-.96-.192-.96s-.216.408-.498.672c-.282.27-.678.54-.678.54s.312-.702.312-1.17c0-.474-.09-1.482-.09-1.482s-.234.384-.474.576c-.24.186-.522.348-.612.468-.084.126.288-.384.324-.696.042-.306.192-1.41 1.152-2.814.564-.822 1.434-2.262 3.3-1.788 1.866.468 1.176 2.982.78 4.152-.39 1.17-.588 2.466-.564 2.922.024.45.348 1.782.306 2.034-.042.246-.144 1.2.084 1.968.24.798.438 1.11.57 1.44.126.33.234.516.276.804.042.288.042.822.042.822s.348-.636.438-.864c.084-.228.084-.9.084-.9s.066.672.588 1.002c.522.33 1.128.678 1.278.864.15.186.198.306.198.306s-.048-1.152-.372-1.602c-.216-.294-1.062-1.254-1.062-1.254s.438.168.738.18c.306.024.522 0 .522 0s-.372-.288-.846-.984c-.48-.696-.282-.756-.63-1.332-.348-.576-.63-.6-1.068-.948-.648-.522-.3-2.604-.216-2.916.09-.306 1.218-2.856 1.242-3.474.018-.618.126-1.998-.96-2.88-.696-.57-1.842-.576-2.106-.738-.258-.168-.774-.678-.774-1.746 0-1.074.384-1.236.69-1.506.306-.264.696-.12.78-.33.09-.204.132-.324.264-.45.126-.12.216-.264.174-.492-.048-.228-.546-.738-.72-1.11-.174-.366-.522-1.338-.522-1.482 0-.144-.042-.594.108-.822 0 0 .546-.636.174-.756-.24-.084-.468.15-.582.12-.324-.084-.498-.282-.588-.27-.216.042-.216.15-.24.456-.018.306-.006.432-.102.432-.132 0-.198-.108-.222-.27-.024-.163-.024-.534-.174-.534s-.366.27-.498.33-.498.12-.522.288c-.018.162.216.51.456.576.24.06.456.18.306.306-.156.12-.306.12-.456 0-.15-.126-.474-.024-.456.162.024.186.066.414.042.516-.018.102-.282.306.06.492.354.186.504-.162.852-.102.348.06.516.186.648.39.132.204.108.636-.132.9-.234.27-.474.312-.564.48-.084.162-.216.552-.216.552s.066-.72.024-.822c-.042-.102-.024-.534-.024-.534s-.234.27-.432.474c-.192.204-.39.822-.39.822s-.018-.576-.018-.804c0-.222.258-.432.174-.516-.09-.078-.498.432-.612.516-.108.084-.456.348-.606.636-.15.288-.264.696-.306.846-.042.144-.114.786-.042.948.108.24.282.678.282.678h-.846c-.456 0-.78.137-.954-.168-.174-.306-.09-.924.126-1.728.222-.798.348-1.188.288-1.332-.066-.144-.348-.474-.456-.535-.114-.065-.414-.041-.546.019-.126.06-.342.162-.756.162s-.672-.018-.822.018c-.156.042-.528.227-.702.186-.174-.042-.474-.192-.39-.433.132-.365-.126-.45-.306-.431-.174.024-.318.084-.54.144-.216.066-.54 0-.498.252.042.246.132.264.24.444.108.191.15.312.024.324-.15.012-.306.03-.42-.066-.12-.096-.306-.306-.456-.228-.156.084-.276.258-.276.648 0 .384-.408.72-.03.702.372-.018.846-.289.93-.078.084.21.036.306-.168.468-.204.162-.456.258-.186.462.27.209.336.209.444.324.102.108.246.474.438.383.372-.179.012-.437.39-.851.372-.414.606-.564 1.236-.499.624.067.798.145.798.325 0 .174-.054.492-.072.624-.012.126.09.594.09.594s-.288-.18-.378-.354c-.078-.174-.252-.48-.252-.48s-.066.36-.048.654c.012.174.072.474.066.534a5.118 5.118 0 01-.138.564s-.096-.438-.168-.564c-.066-.126-.096-.642-.096-.642s-.402.348-.288.93c.078.45-.072 1.044.066 1.236.132.198.45.984 1.236 1.014.78.03 1.386-.03 1.662-.018.27.018 1.236.198 1.236.198s-1.782.911-2.184 1.188c-.408.27-1.038.978-1.242 1.296-.204.324-.39.948-.39.948s-.318-.012-.612-.174a3.08 3.08 0 01-.744-.594c-.168-.192-.438-.63-.438-.63s.048.564.048.738c0 .174-.036.516-.036.516s-.198-.768-.606-1.056c-.408-.294-.882-.69-.882-.69s.048.426.048.528c0 .096.102.594.102.594s-.288-.432-.726-.516c-.444-.078-1.086-.066-1.14-.337-.048-.269.12-.641.018-.833-.102-.193-.324-.324-.324-.324s-.252.21-.474.228c-.216.018-.426-.097-.426-.097s-.186.241-.114.403c.066.156.402.396.324.497-.09.097-.36-.035-.528-.113-.168-.084-.528-.162-.492.113.03.271.12.433.03.625-.084.192-.03.318.108.366.132.048.672-.012.726.114.048.126-.132.288-.492.366-.354.084-.528.294-.342.468.192.18.24.228.324.384.084.162.12.456.444.306.318-.144.252-.498.594-.606.336-.114 1.134.048 1.302.144.168.096.714.498.9.594.186.089.966.672.966.672s-.456.317-.63.48c-.168.162-.468.546-.624.63-.15.078-.9.366-1.152.384-.252.012-1.032.288-1.032.288s.354.114.474.21c.114.096.384.336.522.318.132-.012.168-.012.168-.012s-.726.03-.882.078c-.15.048-.594.324-.762.324-.168 0-.504-.066-.504-.066s.456.288.828.354c.372.06.66.048.66.048s-.576.162-.714.348c-.132.198-.27.48-.372.612-.102.126-.168.336-.354.354-.186.017-.51-.228-.696-.21-.186.018-.324.132-.342.402-.012.275 0 .18-.06.324-.072.144-.342.48-.09.558.258.084.798-.048.852.048.048.095-.288.39-.51.498-.222.114-.576.306-.39.468.186.155.372.222.474.366.102.144.222.546.444.42.216-.126.522-.757.696-.708.168.048.18.498.15.69-.036.192 0 .528.168.498.168-.03.306-.258.576-.276.27-.012.678.065.642-.126-.03-.192-.186-.426-.372-.636-.18-.216-.27-.63-.15-.9.12-.276.426-.714.696-.888.27-.174.78-.306 1.104-.511.318-.209 1.068-.803 1.32-.869.252-.066.51-.192.51-.192s.288.126.678.126c.39 0 1.284-.06 1.626.084.342.144.78.384.648.69-.138.306-.882.576-.816.816.066.24.342.258.798.276.456.012 1.08-.084 1.2.564.12.636.156 1.008-.486 1.152-.648.144-1.122.162-1.242.624-.12.468-.234.582-.102.708.138.126.372.192.846.221.48.037 1.02.037 1.176.15.15.109.18.415.366.547.186.126.918.24.918.24s.876-.426 1.68-1.026c.725-.54 1.38-1.338 1.38-1.338"
        fill="#ed72aa"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M118.83 158.256s-.102.288-.12.372c-.018.078-.072.174-.072.174s.528 0 .51-.162c-.012-.162-.168-.162-.204-.222a.905.905 0 00-.114-.162" />
      <path
        d="M118.83 158.256s-.102.288-.12.372c-.018.078-.072.174-.072.174s.528 0 .51-.162c-.012-.162-.168-.162-.204-.222a.905.905 0 00-.114-.162z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M121.236 159.09l-.036.258s.462 0 .678-.156c.342-.24.558-.612.546-.63-.06-.054-.324.162-.51.222 0 0-.138-.03-.27-.03-.138 0-.204.066-.222.126a.404.404 0 00.018.18l-.204.03" />
      <path
        d="M121.236 159.09l-.036.258s.462 0 .678-.156c.342-.24.558-.612.546-.63-.06-.054-.324.162-.51.222 0 0-.138-.03-.27-.03-.138 0-.204.066-.222.126a.404.404 0 00.018.18z"
        fill="none"
        stroke="#000"
        stroke-width=".03" />
      <path
        d="M124.542 155.46s-.204.288-.252.39c-.054.09-.138.288-.138.288"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M112.128 158.352s.288-.204.51-.24c.222-.03.456-.03.492-.03.03 0 .102.324.066.546-.12.72-.78.882-.78.882s.198-.438.102-.642c-.138-.288-.39-.516-.39-.516"
        fill="#db4446" />
      <path
        d="M112.128 158.352s.288-.204.51-.24c.222-.03.456-.03.492-.03.03 0 .102.324.066.546-.12.72-.78.882-.78.882s.198-.438.102-.642c-.138-.288-.39-.516-.39-.516z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M110.754 157.728s-.258.462-.798.402c-.54-.066-.9-.486-.9-.486s.6.018.75-.078c.222-.144.288-.516.288-.516s.324.192.426.324c.096.126.234.354.234.354"
        fill="#db4446" />
      <path
        d="M110.754 157.728s-.258.462-.798.402c-.54-.066-.9-.486-.9-.486s.6.018.75-.078c.222-.144.288-.516.288-.516s.324.192.426.324c.096.126.234.354.234.354z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M110.094 155.85s-.462-.066-.714-.354c-.258-.294-.216-.84-.216-.84s.3.324.57.324a4 4 0 00.696-.096s-.132.336-.132.48c0 .144-.203.486-.203.486"
        fill="#db4446" />
      <path
        d="M110.094 155.85s-.462-.066-.714-.354c-.258-.294-.216-.84-.216-.84s.3.324.57.324a4 4 0 00.696-.096s-.132.336-.132.48c0 .144-.203.486-.203.486z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path d="M118.848 155.916l.198.318.204-.294z" />
      <path
        d="M118.848 155.916l.198.318.204-.294-.402-.024"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M119.334 155.928l.24.318.258-.288z" />
      <path
        d="M119.334 155.928l.24.318.258-.288-.498-.03"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M119.118 157.902l.492-.174-.444-.228z" />
      <path
        d="M119.118 157.902l.492-.174-.444-.228-.048.402"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M119.712 157.74l.438-.108-.354-.276z" />
      <path
        d="M119.712 157.74l.438-.108-.354-.276-.084.384"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M118.2 148.974s.654.33.846.45c.408.24.696.672.696.672m-3.984.564s.288.498.558.66c.276.156.648.444.75.48.096.03.54.276.54.276m-1.206 1.89s-.48-.138-.66-.402c-.222-.318-.204-.642-.204-.642s.408.336.936.198c.522-.144.576-.198.798-.18.222.018.762.21.762.21s-.444-.516-.39-.87c.048-.348.114-.51.102-.69-.036-.432-.36-.966-.36-.966s.186.114.63.21a2.76 2.76 0 011.05.486c.234.174.54.612.54.612s-.096-.6 0-.852c.102-.264.138-1.002.138-1.002s.282.252.51.372c.114.066.42.228.54.42.084.132.192.636.192.636s.066-.54.234-.804c.168-.252.42-1.044.42-1.044s.174.516.36.726c.186.21.408.48.42.642.018.162-.048.51-.048.51l.234-.51"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M111.636 149.778s-.252.27-.696.192c-.444-.084-.732-.582-.732-.582s.378.102.6.048c.216-.048.372-.27.372-.27s.204.174.27.27c.066.096.186.342.186.342"
        fill="#db4446" />
      <path
        d="M111.636 149.778s-.252.27-.696.192c-.444-.084-.732-.582-.732-.582s.378.102.6.048c.216-.048.372-.27.372-.27s.204.174.27.27c.066.096.186.342.186.342z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M111.126 147.996s-.372.06-.696-.198c-.318-.258-.336-.75-.336-.75s.306.258.546.222c.234-.03.522-.162.522-.162s.048.306.066.383c.054.23-.102.505-.102.505"
        fill="#db4446" />
      <path
        d="M111.126 147.996s-.372.06-.696-.198c-.318-.258-.336-.75-.336-.75s.306.258.546.222c.234-.03.522-.162.522-.162s.048.306.066.383c.054.23-.102.505-.102.505z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M111.996 146.352s-.03-.474.197-.768c.241-.306.68-.354.68-.354s-.145.318-.169.48c-.037.24.204.45.204.45s-.222.228-.438.228c-.222 0-.474-.036-.474-.036"
        fill="#db4446" />
      <path
        d="M111.996 146.352s-.03-.474.197-.768c.241-.306.68-.354.68-.354s-.145.318-.169.48c-.037.24.204.45.204.45s-.222.228-.438.228c-.222 0-.474-.036-.474-.036zM121.998 145.554s1.224-.756 1.188-1.386c-.036-.624-.678-1.446-.678-1.446"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M116.4 142.128s-.306.384-.726.372c-.426-.018-.87-.414-.87-.414s.528.042.666-.132c.138-.18.27-.402.27-.402s.24.126.342.21c.102.078.318.366.318.366"
        fill="#db4446" />
      <path
        d="M116.4 142.128s-.306.384-.726.372c-.426-.018-.87-.414-.87-.414s.528.042.666-.132c.138-.18.27-.402.27-.402s.24.126.342.21c.102.078.318.366.318.366z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M115.098 140.442s-.558.084-.834-.21c-.27-.288-.252-.816-.252-.816s.336.366.642.336c.306-.03.648-.192.648-.192s-.054.318-.09.468c-.03.144-.114.414-.114.414"
        fill="#db4446" />
      <path
        d="M115.098 140.442s-.558.084-.834-.21c-.27-.288-.252-.816-.252-.816s.336.366.642.336c.306-.03.648-.192.648-.192s-.054.318-.09.468c-.03.144-.114.414-.114.414z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M116.304 138.66s-.276-.384-.072-.69c.204-.306.63-.45.63-.45s-.156.222-.084.48c.054.204.402.48.402.48l-.876.18"
        fill="#db4446" />
      <path
        d="M116.304 138.66s-.276-.384-.072-.69c.204-.306.63-.45.63-.45s-.156.222-.084.48c.054.204.402.48.402.48z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M123.744 137.934s-.486.114-.762-.048c-.27-.156-.492-.834-.492-.834s.444.372.768.324c.318-.048.558-.18.558-.18s.048.276.012.468c-.018.114-.084.27-.084.27"
        fill="#db4446" />
      <path
        d="M123.744 137.934s-.486.114-.762-.048c-.27-.156-.492-.834-.492-.834s.444.372.768.324c.318-.048.558-.18.558-.18s.048.276.012.468c-.018.114-.084.27-.084.27z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M123.984 136.14s-.372-.384-.24-.708c.138-.324.372-.66.372-.66s-.012.48.138.612c.222.192.63.222.63.222s-.324.288-.426.324c-.102.03-.474.21-.474.21"
        fill="#db4446" />
      <path
        d="M123.984 136.14s-.372-.384-.24-.708c.138-.324.372-.66.372-.66s-.012.48.138.612c.222.192.63.222.63.222s-.324.288-.426.324c-.102.03-.474.21-.474.21z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M125.85 135.576s-.186-.468.168-.768c.354-.312.666-.342.666-.342s-.276.486-.192.738a.95.95 0 00.324.432s-.444.15-.51.132c-.066-.012-.456-.192-.456-.192"
        fill="#db4446" />
      <path
        d="M125.85 135.576s-.186-.468.168-.768c.354-.312.666-.342.666-.342s-.276.486-.192.738a.95.95 0 00.324.432s-.444.15-.51.132c-.066-.012-.456-.192-.456-.192z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M106.746 102.27c1.254-.379 1.89-1.314 1.89-2.406 0-1.428-1.38-2.508-3.18-2.508-1.794 0-3.252 1.08-3.252 2.508 0 1.074.6 2.28 1.848 2.364 0 0-.036.113-.144.3-.132.138-.384.396-.384.396s.474.09.75-.012c.276-.108.462-.282.462-.282s.126.258.312.456c.18.198.42.318.42.318s.275-.228.366-.384c.09-.162.15-.354.15-.354s.252.21.474.294c.222.09.504.156.504.156s-.078-.276-.132-.414c-.054-.138-.084-.432-.084-.432"
        fill="#ffd691"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M105.192 95.808s-2.388 1.608-3.42 1.824c-1.325.282-2.814.054-3.456.09.018-.018.774-.558 1.105-.888.329-.33 1.433-.99 2.057-1.146 1.932-.486 3.714.12 3.714.12M105.876 95.664s1.524 1.596 3.126 1.812c1.89.264 3.132-.156 3.864-.348.018 0-.606-.294-.936-.522-.33-.222-1.182-.942-2.484-.954-1.308-.018-2.748.138-2.982.102l-.588-.09"
        fill="#058e6e"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M105.414 97.632a3.034 3.034 0 00.006 4.458 3.048 3.048 0 00-.006-4.458"
        fill="#ad1519"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M104.808 94.374s.366.912.402 1.698c.036.654-.09 1.302-.09 1.302h.48s.234-.696.234-1.302c0-.612-.108-1.422-.108-1.422s-.33-.048-.438-.102c-.114-.054-.48-.174-.48-.174"
        fill="#058e6e"
        stroke="#000"
        stroke-width=".312" />
      <path
        d="M135 180.798c0 .342.3.618.66.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M135 180.798c0 .342.3.618.66.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M135.9 182.388c0 .342.294.624.66.624.36 0 .654-.282.654-.624 0-.348-.294-.624-.654-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M135.9 182.388c0 .342.294.624.66.624.36 0 .654-.282.654-.624 0-.348-.294-.624-.654-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M136.5 184.236c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M136.5 184.236c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M136.578 186.216c0 .342.294.618.654.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624"
        fill="#fff" />
      <path
        d="M136.578 186.216c0 .342.294.618.654.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M136.092 188.16c0 .348.294.624.654.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.36 0-.654.282-.654.624"
        fill="#fff" />
      <path
        d="M136.092 188.16c0 .348.294.624.654.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.36 0-.654.282-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M135.078 189.93c0 .348.294.624.654.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.36 0-.654.282-.654.624"
        fill="#fff" />
      <path
        d="M135.078 189.93c0 .348.294.624.654.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.36 0-.654.282-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M133.728 191.388c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624"
        fill="#fff" />
      <path
        d="M133.728 191.388c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M132.156 192.594c0 .342.3.624.66.624.366 0 .66-.282.66-.624s-.294-.623-.66-.623c-.36 0-.66.28-.66.623"
        fill="#fff" />
      <path
        d="M132.156 192.594c0 .342.3.624.66.624.366 0 .66-.282.66-.624s-.294-.623-.66-.623c-.36 0-.66.28-.66.623z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M130.284 193.584c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M130.284 193.584c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M128.34 194.286c0 .342.294.624.66.624.36 0 .66-.282.66-.624s-.3-.624-.66-.624c-.366 0-.66.282-.66.624"
        fill="#fff" />
      <path
        d="M128.34 194.286c0 .342.294.624.66.624.36 0 .66-.282.66-.624s-.3-.624-.66-.624c-.366 0-.66.282-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M126.168 194.676c0 .342.294.624.66.624.36 0 .654-.282.654-.624s-.294-.624-.654-.624c-.366 0-.66.282-.66.624"
        fill="#fff" />
      <path
        d="M126.168 194.676c0 .342.294.624.66.624.36 0 .654-.282.654-.624s-.294-.624-.654-.624c-.366 0-.66.282-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M124.104 194.784c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M124.104 194.784c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M122.082 194.712c0 .342.294.624.66.624.36 0 .654-.282.654-.624s-.294-.624-.654-.624c-.366 0-.66.282-.66.624"
        fill="#fff" />
      <path
        d="M122.082 194.712c0 .342.294.624.66.624.36 0 .654-.282.654-.624s-.294-.624-.654-.624c-.366 0-.66.282-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M120.06 194.712c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624c-.36 0-.654.282-.654.624"
        fill="#fff" />
      <path
        d="M120.06 194.712c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624c-.36 0-.654.282-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M121.068 192.978c0 .342.3.624.66.624a.638.638 0 00.654-.624.638.638 0 00-.654-.624c-.36 0-.66.282-.66.624M121.482 191.058c0 .348.294.624.66.624.36 0 .654-.276.654-.624 0-.342-.294-.618-.654-.618-.366 0-.66.276-.66.618M121.554 189.15c0 .342.3.624.66.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624c-.36 0-.66.282-.66.624M120.96 187.41c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624M119.838 185.808c0 .348.294.624.66.624.36 0 .654-.276.654-.624 0-.342-.294-.618-.654-.618-.366 0-.66.276-.66.618"
        fill="#fff"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M118.524 195.918c0 .342.3.618.66.618.366 0 .66-.276.66-.618 0-.342-.294-.624-.66-.624-.36 0-.66.282-.66.624"
        fill="#fff" />
      <path
        d="M118.524 195.918c0 .342.3.618.66.618.366 0 .66-.276.66-.618 0-.342-.294-.624-.66-.624-.36 0-.66.282-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M116.73 196.914c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624"
        fill="#fff" />
      <path
        d="M116.73 196.914c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M114.744 197.508c0 .348.3.624.66.624.367 0 .66-.276.66-.624 0-.342-.293-.624-.66-.624-.36 0-.66.282-.66.624"
        fill="#fff" />
      <path
        d="M114.744 197.508c0 .348.3.624.66.624.367 0 .66-.276.66-.624 0-.342-.293-.624-.66-.624-.36 0-.66.282-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M112.686 197.862c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.618-.66-.618c-.36 0-.654.276-.654.618"
        fill="#fff" />
      <path
        d="M112.686 197.862c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.618-.66-.618c-.36 0-.654.276-.654.618z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M110.67 197.832c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624"
        fill="#fff" />
      <path
        d="M110.67 197.832c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M108.57 197.478c0 .342.294.618.654.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624"
        fill="#fff" />
      <path
        d="M108.57 197.478c0 .342.294.618.654.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M106.626 196.806c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624c-.36 0-.654.282-.654.624"
        fill="#fff" />
      <path
        d="M106.626 196.806c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624c-.36 0-.654.282-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M73.704 180.798c0 .342.294.618.66.618.36 0 .654-.276.654-.618 0-.348-.294-.624-.654-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M73.704 180.798c0 .342.294.618.66.618.36 0 .654-.276.654-.618 0-.348-.294-.624-.654-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M72.804 182.388c0 .342.294.624.66.624.36 0 .66-.282.66-.624 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M72.804 182.388c0 .342.294.624.66.624.36 0 .66-.282.66-.624 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M72.204 184.236c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M72.204 184.236c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M72.132 186.216c0 .342.294.618.654.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624"
        fill="#fff" />
      <path
        d="M72.132 186.216c0 .342.294.618.654.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M72.618 188.16c0 .348.294.624.654.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.36 0-.654.282-.654.624"
        fill="#fff" />
      <path
        d="M72.618 188.16c0 .348.294.624.654.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.36 0-.654.282-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M73.626 189.93c0 .348.3.624.66.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.36 0-.66.282-.66.624"
        fill="#fff" />
      <path
        d="M73.626 189.93c0 .348.3.624.66.624.366 0 .66-.276.66-.624 0-.342-.294-.624-.66-.624-.36 0-.66.282-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M74.976 191.388c0 .342.3.624.66.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M74.976 191.388c0 .342.3.624.66.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M76.548 192.594c0 .342.294.624.66.624.36 0 .654-.282.654-.624s-.294-.623-.654-.623c-.366 0-.66.28-.66.623"
        fill="#fff" />
      <path
        d="M76.548 192.594c0 .342.294.624.66.624.36 0 .654-.282.654-.624s-.294-.623-.654-.623c-.366 0-.66.28-.66.623z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M78.42 193.584c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M78.42 193.584c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M80.364 194.286c0 .342.294.624.66.624.36 0 .654-.282.654-.624s-.294-.624-.654-.624c-.366 0-.66.282-.66.624"
        fill="#fff" />
      <path
        d="M80.364 194.286c0 .342.294.624.66.624.36 0 .654-.282.654-.624s-.294-.624-.654-.624c-.366 0-.66.282-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M82.542 194.676c0 .342.294.624.655.624.359 0 .659-.282.659-.624s-.3-.624-.66-.624c-.36 0-.654.282-.654.624"
        fill="#fff" />
      <path
        d="M82.542 194.676c0 .342.294.624.655.624.359 0 .659-.282.659-.624s-.3-.624-.66-.624c-.36 0-.654.282-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M84.6 194.784c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M84.6 194.784c0 .342.294.618.66.618.36 0 .66-.276.66-.618 0-.348-.3-.624-.66-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M86.628 194.712c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624c-.36 0-.654.282-.654.624"
        fill="#fff" />
      <path
        d="M86.628 194.712c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624c-.36 0-.654.282-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M88.65 194.712c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624c-.36 0-.654.282-.654.624"
        fill="#fff" />
      <path
        d="M88.65 194.712c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624c-.36 0-.654.282-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M87.636 192.978c0 .342.294.624.66.624.36 0 .66-.282.66-.624s-.3-.624-.66-.624c-.366 0-.66.282-.66.624M87.228 191.058c0 .348.288.624.654.624.366 0 .66-.276.66-.624 0-.342-.294-.618-.66-.618-.366 0-.654.276-.654.618M87.15 189.15c0 .342.294.624.66.624.36 0 .654-.282.654-.624s-.294-.624-.654-.624c-.366 0-.66.282-.66.624M87.75 187.41c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624M88.866 185.808c0 .348.3.624.66.624.366 0 .66-.276.66-.624 0-.342-.294-.618-.66-.618-.36 0-.66.276-.66.618"
        fill="#fff"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M90.18 195.918c0 .342.294.618.66.618.36 0 .654-.276.654-.618 0-.342-.294-.624-.654-.624-.366 0-.66.282-.66.624"
        fill="#fff" />
      <path
        d="M90.18 195.918c0 .342.294.618.66.618.36 0 .654-.276.654-.618 0-.342-.294-.624-.654-.624-.366 0-.66.282-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M91.98 196.914c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624"
        fill="#fff" />
      <path
        d="M91.98 196.914c0 .342.294.624.654.624.366 0 .66-.282.66-.624 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M93.96 197.508c0 .348.294.624.66.624.36 0 .654-.276.654-.624 0-.342-.294-.624-.654-.624-.366 0-.66.282-.66.624"
        fill="#fff" />
      <path
        d="M93.96 197.508c0 .348.294.624.66.624.36 0 .654-.276.654-.624 0-.342-.294-.624-.654-.624-.366 0-.66.282-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M96.024 197.862c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.618-.66-.618c-.36 0-.654.276-.654.618"
        fill="#fff" />
      <path
        d="M96.024 197.862c0 .342.294.624.654.624.366 0 .66-.282.66-.624s-.294-.618-.66-.618c-.36 0-.654.276-.654.618z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M98.04 197.832c0 .342.294.624.66.624.36 0 .654-.282.654-.624 0-.348-.294-.624-.654-.624-.366 0-.66.276-.66.624"
        fill="#fff" />
      <path
        d="M98.04 197.832c0 .342.294.624.66.624.36 0 .654-.282.654-.624 0-.348-.294-.624-.654-.624-.366 0-.66.276-.66.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M100.14 197.478c0 .342.294.618.654.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624"
        fill="#fff" />
      <path
        d="M100.14 197.478c0 .342.294.618.654.618.366 0 .66-.276.66-.618 0-.348-.294-.624-.66-.624-.36 0-.654.276-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M102.084 196.806c0 .342.288.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624a.638.638 0 00-.654.624"
        fill="#fff" />
      <path
        d="M102.084 196.806c0 .342.288.624.654.624.366 0 .66-.282.66-.624s-.294-.624-.66-.624a.638.638 0 00-.654.624z"
        fill="none"
        stroke="#000"
        stroke-width=".234" />
      <path
        d="M93.306 155.292h2.22m-6.378 3.324h2.082m-6.378-3.324h2.214m3.054 1.8v1.11m0-3.33v1.11m0-4.434v1.104m0-3.324v1.11m0-5.55v1.11m0 1.11v1.11m0-5.682v1.248m4.296 11.088v-1.11m-2.082-1.11v-1.104m4.164 1.104v-1.104m-.972 0v-1.11m-2.22 1.11v-1.11m-2.076 1.11v-1.11m1.104 0v-1.11m2.082 1.11v-1.11m2.082 1.11v-1.11m-.972 0v-1.11m-2.22 1.11v-1.11m-2.076 1.11v-1.11m1.104 0v-1.11m-1.104 0v-1.11m0-1.11v-1.104m1.104-1.248v1.248m-1.104-1.248v-1.11m2.076 1.11v-1.11m2.22 1.11v-1.11m-3.192-.972v.972m.972-.972v-1.248m4.302 0v1.248m-2.082-1.248v1.248m-1.11 2.082v1.248m0-3.33v.972m0-3.33v1.11m0-3.33v1.11m1.11 0v1.11m2.082 0v-1.11m-1.11 1.11v1.11m0-3.33v1.11m0 19.272h-4.164m3.192-1.386h-2.22m-7.35 0v-1.11m2.082-1.11v-1.104m-4.158 1.104v-1.104m.972 0v-1.11m2.214 1.11v-1.11m2.082 1.11v-1.11m-1.11 0v-1.11m-2.082 1.11v-1.11m-2.076 1.11v-1.11m.972 0v-1.11m2.214 1.11v-1.11m2.082 1.11v-1.11m-1.11 0v-1.11m1.11 0v-1.11m0-1.11v-1.104m-1.11-1.248v1.248m1.11-1.248v-1.11m-2.082 1.11v-1.11m-2.214 1.11v-1.11m3.186-.972v.972m-.972-.972v-1.248m-4.296 0v1.248m2.082-1.248v1.248m1.104 2.082v1.248m0-3.33v.972m0-3.33v1.11m0-3.33v1.11m-1.104 0v1.11m-2.082 0v-1.11m1.11 1.11v1.11m0-3.33v1.11m0 19.272h4.158m-3.186-1.386h2.214m.972 4.716h4.296m-3.186-1.386h2.082m-2.082-1.11h2.082m-2.082-1.11h2.082m-2.082-1.11h2.082m-6.378-1.11h10.674m-12.756-1.11h14.838m-14.838-1.104h14.838m-14.838-1.11h14.838m-14.838-1.11h14.838m-13.728-1.11h12.618m-12.618-1.11h12.618m-12.618-1.11h12.618m-12.618-1.11h12.618m-12.618-1.104h12.618m-12.618-1.248h12.618m-12.618-1.11h12.618m-14.838-.972h17.052m-17.052-1.248h17.052m-17.052-1.11h17.052m-17.052-1.11h17.052m-17.052-1.11h17.052m-13.308 21.078h-.552v.552h-.972v-2.214h.972v-1.53H82.77v-4.434h1.11v-8.874h-2.22v-4.578h17.052v4.578h-2.214v8.874h1.11v4.434h-2.082v1.53h.972v2.214h-.972v-.552h-.558v.552h-.966v-.552h-.696v.552h-.972v-2.214h.972v-1.53H91.23v4.854h1.104v2.22H91.23v-.558h-.558v.558H89.7v-.558h-.552v.558h-1.11v-2.22h1.11v-4.854h-2.082v1.53h.972v2.214h-.972v-.552h-.552v.552h-1.11z"
        fill="#c8b100" />
      <path
        d="M93.306 155.292h2.22m-6.378 3.324h2.082m-6.378-3.324h2.214m3.054 1.8v1.11m0-3.33v1.11m0-4.434v1.104m0-3.324v1.11m0-5.55v1.11m0 1.11v1.11m0-5.682v1.248m4.296 11.088v-1.11m-2.082-1.11v-1.104m4.164 1.104v-1.104m-.972 0v-1.11m-2.22 1.11v-1.11m-2.076 1.11v-1.11m1.104 0v-1.11m2.082 1.11v-1.11m2.082 1.11v-1.11m-.972 0v-1.11m-2.22 1.11v-1.11m-2.076 1.11v-1.11m1.104 0v-1.11m-1.104 0v-1.11m0-1.11v-1.104m1.104-1.248v1.248m-1.104-1.248v-1.11m2.076 1.11v-1.11m2.22 1.11v-1.11m-3.192-.972v.972m.972-.972v-1.248m4.302 0v1.248m-2.082-1.248v1.248m-1.11 2.082v1.248m0-3.33v.972m0-3.33v1.11m0-3.33v1.11m1.11 0v1.11m2.082 0v-1.11m-1.11 1.11v1.11m0-3.33v1.11m0 19.272h-4.164m3.192-1.386h-2.22m-7.35 0v-1.11m2.082-1.11v-1.104m-4.158 1.104v-1.104m.972 0v-1.11m2.214 1.11v-1.11m2.082 1.11v-1.11m-1.11 0v-1.11m-2.082 1.11v-1.11m-2.076 1.11v-1.11m.972 0v-1.11m2.214 1.11v-1.11m2.082 1.11v-1.11m-1.11 0v-1.11m1.11 0v-1.11m0-1.11v-1.104m-1.11-1.248v1.248m1.11-1.248v-1.11m-2.082 1.11v-1.11m-2.214 1.11v-1.11m3.186-.972v.972m-.972-.972v-1.248m-4.296 0v1.248m2.082-1.248v1.248m1.104 2.082v1.248m0-3.33v.972m0-3.33v1.11m0-3.33v1.11m-1.104 0v1.11m-2.082 0v-1.11m1.11 1.11v1.11m0-3.33v1.11m0 19.272h4.158m-3.186-1.386h2.214m.972 4.716h4.296m-3.186-1.386h2.082m-2.082-1.11h2.082m-2.082-1.11h2.082m-2.082-1.11h2.082m-6.378-1.11h10.674m-12.756-1.11h14.838m-14.838-1.104h14.838m-14.838-1.11h14.838m-14.838-1.11h14.838m-13.728-1.11h12.618m-12.618-1.11h12.618m-12.618-1.11h12.618m-12.618-1.11h12.618m-12.618-1.104h12.618m-12.618-1.248h12.618m-12.618-1.11h12.618m-14.838-.972h17.052m-17.052-1.248h17.052m-17.052-1.11h17.052m-17.052-1.11h17.052m-17.052-1.11h17.052m-13.308 21.078h-.552v.552h-.972v-2.214h.972v-1.53H82.77v-4.434h1.11v-8.874h-2.22v-4.578h17.052v4.578h-2.214v8.874h1.11v4.434h-2.082v1.53h.972v2.214h-.972v-.552h-.558v.552h-.966v-.552h-.696v.552h-.972v-2.214h.972v-1.53H91.23v4.854h1.104v2.22H91.23v-.558h-.558v.558H89.7v-.558h-.552v.558h-1.11v-2.22h1.11v-4.854h-2.082v1.53h.972v2.214h-.972v-.552h-.552v.552h-1.11z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path
        d="M93.03 135.876v2.916c0 .552-.276 2.22-2.91 2.22-2.496 0-2.772-1.668-2.772-2.22v-2.916z"
        fill="#c8b100" />
      <path
        d="M93.03 135.876v2.916c0 .552-.276 2.22-2.91 2.22-2.496 0-2.772-1.668-2.772-2.22v-2.916z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path
        d="M88.314 138.654l-1.386.138c0 .552.138 1.386.558 1.662l1.248-.972c-.138-.138-.42-.552-.42-.828"
        fill="#c8b100" />
      <path
        d="M88.314 138.654l-1.386.138c0 .552.138 1.386.558 1.662l1.248-.972c-.138-.138-.42-.552-.42-.828z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path
        d="M92.058 138.654l1.386.138c0 .552-.138 1.386-.552 1.662l-1.248-.972c.138-.138.414-.552.414-.828"
        fill="#c8b100" />
      <path
        d="M92.058 138.654l1.386.138c0 .552-.138 1.386-.552 1.662l-1.248-.972c.138-.138.414-.552.414-.828z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path
        d="M90.672 140.04l.696 1.248c-.276.138-.834.276-1.248.276-.276 0-.834-.138-1.11-.276l.69-1.248z"
        fill="#c8b100" />
      <path
        d="M90.672 140.04l.696 1.248c-.276.138-.834.276-1.248.276-.276 0-.834-.138-1.11-.276l.69-1.248z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path
        d="M88.038 143.502v3.054c0 .828-.552 1.524-1.524 1.524s-1.524-.696-1.524-1.524v-3.054z"
        fill="#c8b100" />
      <path
        d="M88.038 143.502v3.054c0 .828-.552 1.524-1.524 1.524s-1.524-.696-1.524-1.524v-3.054z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path
        d="M92.334 143.502v3.054c0 .828.558 1.524 1.53 1.524.966 0 1.524-.696 1.524-1.524v-3.054z"
        fill="#c8b100" />
      <path
        d="M92.334 143.502v3.054c0 .828.558 1.524 1.53 1.524.966 0 1.524-.696 1.524-1.524v-3.054z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path d="M91.23 150.99l.276 2.772h-2.634l.138-2.772z" fill="#c8b100" />
      <path
        d="M91.23 150.99l.276 2.772h-2.634l.138-2.772z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path d="M93.306 150.99l-.276 2.772h2.772l-.276-2.772z" fill="#c8b100" />
      <path
        d="M93.306 150.99l-.276 2.772h2.772l-.276-2.772z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path d="M87.066 150.99l.138 2.772H84.57l.282-2.772z" fill="#c8b100" />
      <path
        d="M87.066 150.99l.138 2.772H84.57l.282-2.772z"
        fill="none"
        stroke="#000"
        stroke-width=".276" />
      <path
        d="M92.058 135.876v2.496c0 .42-.276 1.668-1.938 1.668-1.524 0-1.806-1.248-1.806-1.668v-2.496zM87.762 143.784v2.634c0 .69-.414 1.386-1.248 1.386-.834 0-1.248-.696-1.248-1.386v-2.634zM92.616 143.784v2.634c0 .69.414 1.386 1.248 1.386.828 0 1.248-.696 1.248-1.386v-2.634z"
        fill="#0039f0" />
      <path
        d="M95.508 131.394c0 6.066 4.362 10.98 9.75 10.98s9.756-4.914 9.756-10.98c0-6.06-4.368-10.974-9.756-10.974s-9.75 4.914-9.75 10.974"
        fill="#ad1519" />
      <path
        d="M95.508 131.394c0 6.066 4.362 10.98 9.75 10.98s9.756-4.914 9.756-10.98c0-6.06-4.368-10.974-9.756-10.974s-9.75 4.914-9.75 10.974z"
        fill="none"
        stroke="#000"
        stroke-width=".366" />
      <path
        d="M98.4 131.418c0 4.446 3.072 8.046 6.864 8.046 3.786 0 6.858-3.6 6.858-8.046s-3.072-8.052-6.858-8.052c-3.792 0-6.864 3.606-6.864 8.052"
        fill="#005bbf" />
      <path
        d="M98.4 131.418c0 4.446 3.072 8.046 6.864 8.046 3.786 0 6.858-3.6 6.858-8.046s-3.072-8.052-6.858-8.052c-3.792 0-6.864 3.606-6.864 8.052z"
        fill="none"
        stroke="#000"
        stroke-width=".366" />
      <path
        d="M102.018 136.956s-.81-.888-.81-1.716c0-.834.342-1.524.342-1.524a.896.896 0 01-.846.564c-.498 0-.9-.378-.9-.852 0-.132.084-.348.144-.462l.294-.594c.096.222.324.342.588.342.354 0 .648-.27.648-.606a.414.414 0 00-.024-.15l-.732-.006v-.618h.654l-.486-.966.642.252.486-.546.504.546.642-.252-.48.966h.648v.618l-.732.006c-.012.048-.012.096-.012.15a.62.62 0 00.636.606c.264 0 .492-.12.588-.342l.294.594c.06.114.144.33.144.462 0 .474-.402.852-.894.852a.885.885 0 01-.846-.564s.342.69.342 1.524c0 .828-.834 1.716-.834 1.716"
        fill="#c8b100" />
      <path
        d="M102.018 136.956s-.81-.888-.81-1.716c0-.834.342-1.524.342-1.524a.896.896 0 01-.846.564c-.498 0-.9-.378-.9-.852 0-.132.084-.348.144-.462l.294-.594c.096.222.324.342.588.342.354 0 .648-.27.648-.606a.414.414 0 00-.024-.15l-.732-.006v-.618h.654l-.486-.966.642.252.486-.546.504.546.642-.252-.48.966h.648v.618l-.732.006c-.012.048-.012.096-.012.15a.62.62 0 00.636.606c.264 0 .492-.12.588-.342l.294.594c.06.114.144.33.144.462 0 .474-.402.852-.894.852a.885.885 0 01-.846-.564s.342.69.342 1.524c0 .828-.834 1.716-.834 1.716z"
        fill="none"
        stroke="#000"
        stroke-width=".204"
        stroke-linejoin="round" />
      <path
        d="M100.722 131.334h2.616v.618h-2.616z"
        fill="#c8b100"
        stroke="#000"
        stroke-width=".204" />
      <path
        d="M108.396 136.956s-.81-.888-.81-1.716c0-.834.342-1.524.342-1.524a.897.897 0 01-.846.564c-.498 0-.9-.378-.9-.852 0-.132.084-.348.144-.462l.294-.594c.096.222.323.342.588.342.36 0 .642-.27.642-.606a.604.604 0 00-.018-.15l-.732-.006v-.618h.654l-.487-.966.643.252.486-.546.504.546.641-.252-.485.966h.654v.618l-.732.006a.604.604 0 00-.018.15c0 .336.288.606.642.606.264 0 .492-.12.588-.342l.294.594c.06.114.144.33.144.462 0 .474-.402.852-.894.852a.905.905 0 01-.852-.564s.348.69.348 1.524c0 .828-.834 1.716-.834 1.716"
        fill="#c8b100" />
      <path
        d="M108.396 136.956s-.81-.888-.81-1.716c0-.834.342-1.524.342-1.524a.897.897 0 01-.846.564c-.498 0-.9-.378-.9-.852 0-.132.084-.348.144-.462l.294-.594c.096.222.323.342.588.342.36 0 .642-.27.642-.606a.604.604 0 00-.018-.15l-.732-.006v-.618h.654l-.487-.966.643.252.486-.546.504.546.641-.252-.485.966h.654v.618l-.732.006a.604.604 0 00-.018.15c0 .336.288.606.642.606.264 0 .492-.12.588-.342l.294.594c.06.114.144.33.144.462 0 .474-.402.852-.894.852a.905.905 0 01-.852-.564s.348.69.348 1.524c0 .828-.834 1.716-.834 1.716z"
        fill="none"
        stroke="#000"
        stroke-width=".204"
        stroke-linejoin="round" />
      <path d="M107.1 131.334h2.61v.618h-2.61z" fill="#c8b100" stroke="#000" stroke-width=".204" />
      <path
        d="M105.21 131.472s-.816-.894-.816-1.722.342-1.518.342-1.518a.9.9 0 01-.846.564c-.498 0-.9-.378-.9-.852 0-.138.084-.348.15-.468l.288-.588c.102.216.324.342.594.342.354 0 .642-.27.642-.612a.414.414 0 00-.024-.15h-.726v-.624h.654l-.486-.96.642.252.486-.546.504.546.642-.252-.492.96h.66v.624h-.732a.604.604 0 00-.018.15c0 .342.282.612.642.612.264 0 .486-.126.588-.342l.294.588c.06.12.144.33.144.468 0 .474-.402.852-.9.852-.39 0-.72-.24-.846-.564 0 0 .342.69.342 1.518 0 .828-.834 1.722-.834 1.722"
        fill="#c8b100" />
      <path
        d="M105.21 131.472s-.816-.894-.816-1.722.342-1.518.342-1.518a.9.9 0 01-.846.564c-.498 0-.9-.378-.9-.852 0-.138.084-.348.15-.468l.288-.588c.102.216.324.342.594.342.354 0 .642-.27.642-.612a.414.414 0 00-.024-.15h-.726v-.624h.654l-.486-.96.642.252.486-.546.504.546.642-.252-.492.96h.66v.624h-.732a.604.604 0 00-.018.15c0 .342.282.612.642.612.264 0 .486-.126.588-.342l.294.588c.06.12.144.33.144.468 0 .474-.402.852-.9.852-.39 0-.72-.24-.846-.564 0 0 .342.69.342 1.518 0 .828-.834 1.722-.834 1.722z"
        fill="none"
        stroke="#000"
        stroke-width=".204"
        stroke-linejoin="round" />
      <path d="M103.914 125.844h2.61v.624h-2.61z" fill="#c8b100" stroke="#000" stroke-width=".204" />
      <path
        d="M124.728 160.374l-.174-.012a.895.895 0 00-.156-.21c-.156-.15-.39-.168-.516-.042a.291.291 0 00-.084.246.295.295 0 00-.306.006c-.156.09-.192.3-.084.474.018.036.036.084.066.108l-.012.192-.21-.048-.06-.114c-.132-.15-.324-.186-.42-.102a.315.315 0 00-.078.162.221.221 0 00-.102-.066c-.324-.078-.45.63-.462.81l-.102-.15s.096-.42.048-.78a4.214 4.214 0 00-.174-.714c.444-.114 1.116-.48 1.782-.99.666-.51 1.188-1.068 1.404-1.452 0 0 .348.192.708.306.36.114.816.12.816.12l.132.126c-.192-.03-.948-.06-.936.258 0 .048.042.108.048.108a.418.418 0 00-.18.036c-.108.078-.108.258.012.414l.108.078.006.204-.204-.03c-.018-.024-.066-.054-.09-.078-.162-.138-.39-.15-.516-.018a.25.25 0 00-.066.276.348.348 0 00-.27.03c-.156.09-.186.312-.066.48a.8.8 0 00.186.192l-.042.18"
        fill="#c8b100" />
      <path
        d="M124.728 160.374l-.174-.012a.895.895 0 00-.156-.21c-.156-.15-.39-.168-.516-.042a.291.291 0 00-.084.246.295.295 0 00-.306.006c-.156.09-.192.3-.084.474.018.036.036.084.066.108l-.012.192-.21-.048-.06-.114c-.132-.15-.324-.186-.42-.102a.315.315 0 00-.078.162.221.221 0 00-.102-.066c-.324-.078-.45.63-.462.81l-.102-.15s.096-.42.048-.78a4.214 4.214 0 00-.174-.714c.444-.114 1.116-.48 1.782-.99.666-.51 1.188-1.068 1.404-1.452 0 0 .348.192.708.306.36.114.816.12.816.12l.132.126c-.192-.03-.948-.06-.936.258 0 .048.042.108.048.108a.418.418 0 00-.18.036c-.108.078-.108.258.012.414l.108.078.006.204-.204-.03c-.018-.024-.066-.054-.09-.078-.162-.138-.39-.15-.516-.018a.25.25 0 00-.066.276.348.348 0 00-.27.03c-.156.09-.186.312-.066.48a.8.8 0 00.186.192l-.042.18z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M123.378 159.96c.03.042.09.036.138 0 .048-.036.06-.096.036-.126-.03-.036-.09-.036-.144.006-.042.03-.06.09-.03.12" />
      <path
        d="M123.378 159.96c.03.042.09.036.138 0 .048-.036.06-.096.036-.126-.03-.036-.09-.036-.144.006-.042.03-.06.09-.03.12z"
        fill="none"
        stroke="#000"
        stroke-width=".03" />
      <path
        d="M123.948 159.486l-.198.15c-.036.024-.042.072-.024.096.024.024.072.024.108 0l.198-.156.198-.15c.03-.024.048-.072.024-.096-.024-.024-.072-.024-.108 0l-.198.156M122.904 160.2l-.156.09c-.042.024-.06.072-.042.102.018.03.066.036.102.012l.156-.096.156-.09c.036-.018.054-.066.042-.096-.018-.03-.066-.036-.102-.012l-.156.09"
        stroke="#000"
        stroke-width=".03" />
      <path
        d="M122.28 160.626c.03.036.096.036.144 0 .048-.042.06-.096.03-.132-.03-.03-.09-.03-.138.006-.048.036-.06.09-.036.126" />
      <path
        d="M122.28 160.626c.03.036.096.036.144 0 .048-.042.06-.096.03-.132-.03-.03-.09-.03-.138.006-.048.036-.06.09-.036.126z"
        fill="none"
        stroke="#000"
        stroke-width=".03" />
      <path
        d="M124.578 159.048c.03.03.018.084-.03.126-.048.036-.114.036-.144 0-.024-.03-.012-.09.036-.126.048-.036.108-.036.138 0" />
      <path
        d="M124.578 159.048c.03.03.018.084-.03.126-.048.036-.114.036-.144 0-.024-.03-.012-.09.036-.126.048-.036.108-.036.138 0z"
        fill="none"
        stroke="#000"
        stroke-width=".03" />
      <path
        d="M124.92 158.652l.132-.126c.03-.03.078-.042.108-.018.024.024.024.066-.006.096l-.126.126-.132.126c-.03.03-.084.042-.108.018-.03-.018-.024-.066.006-.096l.126-.126"
        stroke="#000"
        stroke-width=".03" />
      <path
        d="M125.49 158.166c.03.036.018.09-.03.126-.048.042-.108.042-.138.006-.03-.036-.018-.09.03-.132.048-.03.108-.036.138 0" />
      <path
        d="M125.49 158.166c.03.036.018.09-.03.126-.048.042-.108.042-.138.006-.03-.036-.018-.09.03-.132.048-.03.108-.036.138 0z"
        fill="none"
        stroke="#000"
        stroke-width=".03" />
      <path d="M123.84 161.784l-.354-.006-.066-.522.036-.084.09.006.456.306z" fill="#c8b100" />
      <path
        d="M123.84 161.784l-.354-.006-.066-.522.036-.084.09.006.456.306-.162.3"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M122.88 161.496l-.012-.324.552-.072.09.041-.012.091-.318.426z" fill="#c8b100" />
      <path
        d="M122.88 161.496l-.012-.324.552-.072.09.041-.012.091-.318.426-.3-.162"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M124.02 160.848l-.294-.162-.324.426-.006.09.084.036.558-.066z" fill="#c8b100" />
      <path
        d="M124.02 160.848l-.294-.162-.324.426-.006.09.084.036.558-.066-.018-.324"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M123.306 161.25a.173.173 0 00.234.054.154.154 0 00.06-.222.173.173 0 00-.234-.054.156.156 0 00-.06.222"
        fill="#c8b100" />
      <path
        d="M123.306 161.25a.173.173 0 00.234.054.154.154 0 00.06-.222.173.173 0 00-.234-.054.156.156 0 00-.06.222z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M122.016 161.79c-.012-.006-.078.276-.156.426-.048.114-.234.258-.234.258.018.03.252.114.522-.054.228-.186-.018-.522-.018-.522s-.054-.084-.114-.108"
        fill="#c8b100" />
      <path
        d="M122.016 161.79c-.012-.006-.078.276-.156.426-.048.114-.234.258-.234.258.018.03.252.114.522-.054.228-.186-.018-.522-.018-.522s-.054-.084-.114-.108z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M122.634 161.604l-.252-.222-.408.36.036.048.018.09.552.042z" fill="#c8b100" />
      <path
        d="M122.634 161.604l-.252-.222-.408.36.036.048.018.09.552.042.054-.318"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M121.944 161.826c.03.09.108.138.168.12.066-.024.09-.108.06-.198-.03-.09-.108-.138-.174-.12-.066.024-.09.108-.054.198"
        fill="#c8b100" />
      <path
        d="M121.944 161.826c.03.09.108.138.168.12.066-.024.09-.108.06-.198-.03-.09-.108-.138-.174-.12-.066.024-.09.108-.054.198z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M125.202 160.938l-.354.036-.15-.51.03-.084.09-.006.498.246z" fill="#c8b100" />
      <path
        d="M125.202 160.938l-.354.036-.15-.51.03-.084.09-.006.498.246-.114.318"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M124.206 160.782l-.06-.324.54-.138.09.024.006.084-.258.474z" fill="#c8b100" />
      <path
        d="M124.206 160.782l-.06-.324.54-.138.09.024.006.084-.258.474-.318-.12"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M125.238 159.984l-.318-.12-.252.468.006.09.09.018.534-.138z" fill="#c8b100" />
      <path
        d="M125.238 159.984l-.318-.12-.252.468.006.09.09.018.534-.138-.06-.318"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M124.59 160.476c.06.072.168.078.24.024a.153.153 0 00.03-.228c-.06-.072-.168-.078-.246-.024a.157.157 0 00-.024.228"
        fill="#c8b100" />
      <path
        d="M124.59 160.476c.06.072.168.078.24.024a.153.153 0 00.03-.228c-.06-.072-.168-.078-.246-.024a.157.157 0 00-.024.228z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M126.384 159.834l.066-.33-.522-.18-.096.024-.006.084.216.486z" fill="#c8b100" />
      <path
        d="M126.384 159.834l.066-.33-.522-.18-.096.024-.006.084.216.486.342-.084"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M126.294 158.88l-.336-.078-.186.498.025.09.089.012.51-.21z" fill="#c8b100" />
      <path
        d="M126.294 158.88l-.336-.078-.186.498.025.09.089.012.51-.21-.102-.312"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M125.382 159.804l-.108-.312.51-.204.096.012.018.084-.18.498z" fill="#c8b100" />
      <path
        d="M125.382 159.804l-.108-.312.51-.204.096.012.018.084-.18.498-.336-.078"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M125.946 159.222a.165.165 0 01.012.234.19.19 0 01-.246.012c-.066-.066-.072-.168-.006-.234a.176.176 0 01.24-.012"
        fill="#c8b100" />
      <path
        d="M125.946 159.222a.165.165 0 01.012.234.19.19 0 01-.246.012c-.066-.066-.072-.168-.006-.234a.176.176 0 01.24-.012z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M126.774 158.142c0-.006.3-.018.474-.054.12-.024.312-.162.312-.162.036.024.072.252-.168.474-.234.168-.528-.132-.528-.132s-.072-.071-.09-.126"
        fill="#c8b100" />
      <path
        d="M126.774 158.142c0-.006.3-.018.474-.054.12-.024.312-.162.312-.162.036.024.072.252-.168.474-.234.168-.528-.132-.528-.132s-.072-.071-.09-.126z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path d="M126.45 158.676l-.174-.276.456-.306.054.048.078.024-.072.528z" fill="#c8b100" />
      <path
        d="M126.45 158.676l-.174-.276.456-.306.054.048.078.024-.072.528-.342-.018"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M126.822 158.082c.084.042.126.132.09.186-.036.054-.132.06-.216.012-.084-.048-.12-.132-.084-.186.03-.054.126-.06.21-.012"
        fill="#c8b100" />
      <path
        d="M126.822 158.082c.084.042.126.132.09.186-.036.054-.132.06-.216.012-.084-.048-.12-.132-.084-.186.03-.054.126-.06.21-.012z"
        fill="none"
        stroke="#000"
        stroke-width=".156" />
      <path
        d="M150.678 171.816v-.348h-1.518v.348h.564v.78h-.372v.348h.372v.348h.366v-.348h.366v-.348h-.366v-.78h.588"
        fill="none"
        stroke="#000"
        stroke-width=".18" />
      <path d="M60.264 164.31v.762" fill="none" stroke="#000" stroke-width=".012" />
      <path d="M60.054 164.31v.762" fill="none" stroke="#000" stroke-width=".018" />
      <path
        d="M59.862 164.31v.762M59.664 164.31v.762"
        fill="none"
        stroke="#000"
        stroke-width=".024" />
      <path d="M59.496 164.31v.762" fill="none" stroke="#000" stroke-width=".03" />
      <path
        d="M59.322 164.34v.726m-.156-.714l-.006.69"
        fill="none"
        stroke="#000"
        stroke-width=".036" />
      <path
        d="M59.016 164.364l-.006.678m-.15-.66v.636"
        fill="none"
        stroke="#000"
        stroke-width=".042" />
      <path
        d="M58.728 164.388V165m-.138-.588V165m-.138-.582v.558"
        fill="none"
        stroke="#000"
        stroke-width=".048" />
      <path d="M58.314 164.424v.54" fill="none" stroke="#000" stroke-width=".054" />
      <path d="M58.182 164.448v.51" fill="none" stroke="#000" stroke-width=".06" />
      <path d="M58.038 164.466v.468" fill="none" stroke="#000" stroke-width=".066" />
      <path
        d="M57.894 164.484v.42m-.15-.396l-.006.372M57.594 164.538v.33"
        fill="none"
        stroke="#000"
        stroke-width=".072" />
      <path d="M57.456 164.562v.276" fill="none" stroke="#000" stroke-width=".078" />
      <path d="M57.306 164.598v.216" fill="none" stroke="#000" stroke-width=".084" />
      <path d="M57.156 164.616v.162" fill="none" stroke="#000" stroke-width=".09" />
      <path d="M56.994 164.652v.078" fill="none" stroke="#000" stroke-width=".108" />
      <path
        d="M60.48 164.316v.756m.252-.744l.006.738m.342-.714v.696"
        fill="none"
        stroke="#000"
        stroke-width=".006" />
      <path d="M149.862 164.298v.762" fill="none" stroke="#000" stroke-width=".012" />
      <path d="M149.652 164.298v.762" fill="none" stroke="#000" stroke-width=".018" />
      <path
        d="M149.46 164.298v.762M149.268 164.298v.762"
        fill="none"
        stroke="#000"
        stroke-width=".024" />
      <path d="M149.094 164.298v.762" fill="none" stroke="#000" stroke-width=".03" />
      <path
        d="M148.92 164.328v.726m-.156-.714l-.007.69"
        fill="none"
        stroke="#000"
        stroke-width=".036" />
      <path
        d="M148.614 164.352l-.006.678m-.144-.66v.636"
        fill="none"
        stroke="#000"
        stroke-width=".042" />
      <path
        d="M148.326 164.376v.612m-.138-.594v.588m-.132-.576v.558"
        fill="none"
        stroke="#000"
        stroke-width=".048" />
      <path d="M147.912 164.412v.54" fill="none" stroke="#000" stroke-width=".054" />
      <path d="M147.78 164.436v.504" fill="none" stroke="#000" stroke-width=".06" />
      <path d="M147.636 164.448v.474" fill="none" stroke="#000" stroke-width=".066" />
      <path
        d="M147.492 164.472v.42m-.144-.402l-.006.378M147.192 164.526v.324"
        fill="none"
        stroke="#000"
        stroke-width=".072" />
      <path d="M147.06 164.55v.276" fill="none" stroke="#000" stroke-width=".078" />
      <path d="M146.91 164.586v.216" fill="none" stroke="#000" stroke-width=".084" />
      <path d="M146.754 164.604v.162" fill="none" stroke="#000" stroke-width=".09" />
      <path d="M146.592 164.64v.078" fill="none" stroke="#000" stroke-width=".108" />
      <path
        d="M150.078 164.304v.756m.258-.744v.738m.348-.714v.696"
        fill="none"
        stroke="#000"
        stroke-width=".006" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Es',
};
</script>

<style>
</style>
